<template>
    <div>
        <buttonlist @help="help" @opentable="opentable" @add="add" @search="search" @reflash="reflash" @exps="exps" @save="save" @del="del"
                    ref="SetBtn"></buttonlist>
        <ul class="Boxs" ref="Box" :style="{ height: tableHeight + 'px' }">
            <li class="left" ref="left">
                <div class="btnnowrap" style="margin-top: 2px">
                    <el-button type="primary" size="mini" @click="batchBalance" :disabled="!btn.batchbalance">{{
                        $t('getapi[5078]') }}
                    </el-button>
                    <el-button type="primary" size="mini" @click="batchNoBalance" :disabled="!btn.batchrbalance">{{
                        $t('getapi[5079]') }}</el-button>
                    <el-button type="primary" size="mini" @click="beforeUpdateUserStatus" :disabled="!btn.cmuuser">{{$t('getapi[7221]')}}</el-button>
                    <el-button type="primary" size="mini" @click="beforeBatchAudit" :disabled="!btn.batchaudit">{{
                        $t('getapi[1315]') }}</el-button>
                </div>
                <wTable
                        id="xpane-0"
                        :data="dataSet"
                        :loading="loading"
                        queryData="PurInvoiceListViewInfo"
                        :filter_language="['invoice_status','virtual_flag','img','invoice_usestatus','balancemode_name','negative_flag']"
                        :filter_thousandth_puramount="['remain_amount','vender_remain_amount','diff_amount','diff_net_amount','net_total_amount','vender_net_total_amount','total_amount','tax_total_amount']"
                        :filter_date="['invoice_date','payment_date']"
                        :header="tableHeader"
                        :option="tableOption"
                        @handleSelectionChange="handleSelectionChange"
                        @edits="editInfo"
                        @rowdblclick="openEdit"
                        ref="singleTable"
                ></wTable>
                <!--<el-table
                        :data="dataSet"
                        ref="singleTable"
                        v-loading="loading"
                        :highlight-current-row="true"
                        show-overflow-tooltip="true"
                        border
                        stripe
                        size="mini"
                        :height="tableHeight-reduceTableHeight"
                        header-row-class-name="headerclass"
                        @row-click="editInfo"
                        @row-dblclick="openEdit"
                        @selection-change="handleSelectionChange"
                        style="width: 100%; margin-top:0px"
                >
                    <el-table-column type="selection"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="create_year" :label="$t('getapi[3677]')" align="right" sortable></el-table-column>
                    <el-table-column show-overflow-tooltip prop="audit_year" :label="$t('getapi[3679]')" align="right" sortable></el-table-column>
                    <el-table-column show-overflow-tooltip prop="audit_month" :label="$t('getapi[3680]')" align="right" sortable></el-table-column>
                    <el-table-column show-overflow-tooltip prop="create_month" :label="$t('getapi[3678]')" align="right" sortable></el-table-column>
                    <el-table-column show-overflow-tooltip prop="invoice_no" :label="$t('getapi[2992]')" sortable></el-table-column>
                    <el-table-column show-overflow-tooltip prop="invoice_code" :label="$t('getapi[3681]')" sortable></el-table-column>
                    <el-table-column show-overflow-tooltip prop="invoice_type_name" :label="$t('getapi[3682]')" sortable></el-table-column>
                    <el-table-column show-overflow-tooltip prop="invoice_date" :label="$t('getapi[3683]')" sortable></el-table-column>
                    <el-table-column show-overflow-tooltip prop="order_type_code" :label="$t('getapi[3684]')" sortable></el-table-column>
                    <el-table-column show-overflow-tooltip prop="balancemode_name" :label="$t('getapi[1228]')" sortable></el-table-column>
                    <el-table-column show-overflow-tooltip prop="vender_code" :label="$t('getapi[1196]')" sortable></el-table-column>
                    <el-table-column show-overflow-tooltip prop="vender_name" :label="$t('getapi[3685]')" sortable></el-table-column>
                    <el-table-column show-overflow-tooltip prop="payment_date" :label="$t('getapi[3686]')" sortable></el-table-column>
                    <el-table-column show-overflow-tooltip prop="currency_code" :label="$t('getapi[3108]')" sortable></el-table-column>
                    <el-table-column show-overflow-tooltip prop="exchange_rate" :label="$t('getapi[3287]')" align="right" sortable></el-table-column>
                    <el-table-column show-overflow-tooltip prop="remain_amount" :label="$t('getapi[3688]')" align="right" sortable></el-table-column>
                    <el-table-column show-overflow-tooltip prop="vender_remain_amount" :label="$t('getapi[3689]')" align="right" sortable></el-table-column>
                    <el-table-column show-overflow-tooltip prop="create_person" :label="$t('getapi[3690]')" sortable></el-table-column>
                    <el-table-column show-overflow-tooltip prop="create_date" :label="$t('getapi[3691]')" sortable></el-table-column>
                    <el-table-column show-overflow-tooltip prop="audit_person" :label="$t('getapi[4043]')" sortable></el-table-column>
                    <el-table-column show-overflow-tooltip prop="audit_date" :label="$t('getapi[3692]')" sortable></el-table-column>
                    <el-table-column show-overflow-tooltip prop="payment_period" :label="$t('getapi[1600]')" align="right" sortable></el-table-column>
                    <el-table-column show-overflow-tooltip prop="tax_code" :label="$t('getapi[3693]')" sortable></el-table-column>
                    <el-table-column show-overflow-tooltip prop="tax_rate" :label="$t('getapi[1225]')" align="right" sortable></el-table-column>
                    <el-table-column show-overflow-tooltip prop="invoice_status" :label="$t('getapi[3694]')" sortable></el-table-column>
                    <el-table-column show-overflow-tooltip prop="exchange_modify_person" :label="$t('getapi[3695]')" sortable></el-table-column>
                    <el-table-column show-overflow-tooltip prop="exchange_modify_date" :label="$t('getapi[3696]')" sortable></el-table-column>
                    <el-table-column show-overflow-tooltip prop="audit_period" :label="$t('getapi[3697]')" sortable></el-table-column>
                    <el-table-column show-overflow-tooltip prop="diff_amount" :label="$t('getapi[3698]')" align="right" sortable></el-table-column>
                    <el-table-column show-overflow-tooltip prop="diff_net_amount" :label="$t('getapi[3699]')" align="right" sortable></el-table-column>
                    <el-table-column show-overflow-tooltip prop="virtual_flag" :label="$t('getapi[3700]')" sortable></el-table-column>
                    <el-table-column show-overflow-tooltip prop="net_total_amount" :label="$t('getapi[3701]')" align="right" width="120" sortable></el-table-column>
                    <el-table-column show-overflow-tooltip prop="vender_net_total_amount" :label="$t('getapi[3702]')" align="right" width="120" sortable></el-table-column>
                    <el-table-column show-overflow-tooltip prop="total_amount" :label="$t('getapi[3703]')" align="right" width="120" sortable></el-table-column>
                    <el-table-column show-overflow-tooltip prop="tax_total_amount" :label="$t('getapi[3704]')" align="right" sortable></el-table-column>
                    <el-table-column show-overflow-tooltip prop="negative_flag" :label="$t('getapi[3705]')" sortable></el-table-column>
                    <el-table-column show-overflow-tooltip prop="img" :label="$t('getapi[6391]')"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="invoicenumlst" :label="$t('getapi[7222]')" sortable></el-table-column>
                    <el-table-column show-overflow-tooltip prop="invoice_usestatus" :label="$t('getapi[7223]')" sortable></el-table-column>
                </el-table>-->
            </li>
            <li class="resize" ref="resize">
                <i class="el-icon-caret-right" @click="leftt(0)"></i>
                <i class="el-icon-caret-left" @click="leftt(1)"></i>
            </li>
            <li class="mid" ref="mid">
                <div  style="float:right;position: relative;">
                    <el-button type="danger" size="mini" icon="el-icon-close" @click="colseEdit"></el-button>
                </div>
                <div  v-if="negative_flag == 0">
                    <div>
                        <div class="btnnowrap">
                            <el-button type="primary" size="mini" @click="beforeAuditPurInvoice" :disabled="!btn.audit || addoredit == 0">{{
                                $t('getapi[3607]') }}
                            </el-button>
                            <el-button type="primary" size="mini" @click="rAuditPurInvoice" :disabled="!btn.raudit">{{
                                $t('getapi[1334]') }}
                            </el-button>
                            <el-button type="primary" size="mini" @click="balancePurInvoice" :disabled="!btn.balance">{{
                                $t('getapi[1868]') }}
                            </el-button>
                            <el-button type="primary" size="mini" @click="rBalancePurInvoice" :disabled="!btn.rbalance">{{
                                $t('getapi[1869]') }}
                            </el-button>
                            <el-button type="primary" size="mini" @click="beforeSetRatePurInvoice" :disabled="!btn.setrate">{{
                                $t('getapi[3878]') }}
                            </el-button>
                            <el-button type="primary" size="mini" @click="beforeSetTaxRatePurInvoice" :disabled="!btn.settaxrate">
                                {{$t('getapi[7224]')}}
                            </el-button>
                            <el-button type="primary" size="mini" @click="beforeSetChangeTaxRatePurInvoice" :disabled="!btn.settaxrateback">{{$t('getapi[7225]')}}
                            </el-button>
                            <el-button type="primary" size="mini" @click="beforeChangeAuditDate" :disabled="!btn.editauditdate">{{$t('getapi[3722]')}}
                            </el-button>
                            <el-button type="primary" size="mini" @click="beforeChangePayDate" :disabled="!btn.fkrq">{{$t('getapi[7226]')}}
                            </el-button>
                            <el-radio v-model="billmode" label="1" style="margin-left: 8px">{{$t('getapi[3978]')}}</el-radio>
                            <el-radio v-model="billmode" label="2">{{$t('getapi[3979]')}}</el-radio>
                        </div>
                        <div style="width:1080px;min-width:1080px">
                            <table>
                                <tr>
                                    <td style="width:60px;min-width:60px">{{ $t('getapi[2992]') }}</td>
                                    <td style="width:160px;min-width:160px">
                                        <el-input  type="text" size="mini" v-model="dataDetail.Head.invoice_no"  class="mcolor" v-show="dataDetail.Head.invoice_status == 0 && addoredit == 0"
                                        ></el-input>
                                        <el-input type="text" size="mini" v-model="dataDetail.Head.invoice_no" :readonly="true" class="readO" v-show="dataDetail.Head.invoice_status != 0 || addoredit != 0"></el-input>
                                    </td>
                                    <td style="width:60px;min-width:60px">{{ $t('getapi[3682]') }}</td>
                                    <td style="width:160px;min-width:160px">
                                        <el-select filterable v-model="dataDetail.Head.invoice_type_code" size="mini" :disabled="dataDetail.Head.invoice_status != 0">
                                            <el-option v-for="item in invoiceType" :key="item.Code" :label="item.Name"
                                                       :value="item.Code"></el-option>
                                        </el-select>
                                    </td>
                                    <td style="width:60px;min-width:60px">{{ $t('getapi[3686]') }}</td>
                                    <td style="width:160px;min-width:160px">
                                        <el-date-picker v-model="dataDetail.Head.payment_date" type="date" size="mini"
                                                        style="width:100%" :readonly="true" class="readO"></el-date-picker>
                                    </td>
                                    <td style="width:60px;min-width:60px">{{ $t('getapi[3694]') }}</td>
                                    <td style="width:100px;min-width:100px">
                                        <el-input  type="text" size="mini" :value="expInvoiceStatus(dataDetail.Head.invoice_status)" :readonly="true" class="readO"
                                        ></el-input>
                                    </td>
                                    <td style="width:60px;min-width:60px">{{ $t('getapi[3287]') }}</td>
                                    <td style="width:100px;min-width:100px">
                                        <el-input  type="text" size="mini" v-model="dataDetail.Head.exchange_rate" :readonly="true" class="readO"
                                        ></el-input>
                                    </td>
                                </tr>
                                <tr>
                                    <td>{{ $t('getapi[3681]') }}</td>
                                    <td>
                                        <el-input  type="text" size="mini" v-model="dataDetail.Head.invoice_code" :readonly="dataDetail.Head.invoice_status != 0" :class="{'readO':dataDetail.Head.invoice_status != 0}"
                                        ></el-input>
                                    </td>
                                    <td>{{ $t('getapi[3683]') }}</td>
                                    <td>
                                        <el-date-picker v-model="dataDetail.Head.invoice_date" type="date" size="mini"
                                                        style="width:100%" :readonly="dataDetail.Head.invoice_status != 0" :class="{'readO':dataDetail.Head.invoice_status != 0}"></el-date-picker>
                                    </td>
                                    <td>{{ $t('getapi[1976]') }}</td>
                                    <td>
                                        <el-select filterable v-model="dataDetail.Head.order_type_code" size="mini" :disabled="true">
                                            <el-option v-for="item in invoiceOrderType" :key="item.Code" :label="item.Name"
                                                       :value="item.Code"></el-option>
                                        </el-select>
                                    </td>
                                    <td>{{ $t('getapi[3748]') }}</td>
                                    <td>
                                        <el-input  type="number" autocomplete="off" title="" @mousewheel.native.prevent size="mini" :value="dataDetail.Head.total_amount" :readonly="true" class="readO"
                                        ></el-input>
                                    </td>
                                    <td>
                                        <el-checkbox v-model="dataDetail.Head.charge_invoice_flag" true-label="1" false-label="0" :disabled="true"></el-checkbox>
                                        {{ $t('getapi[3724]') }}
                                    </td>
                                    <td >
                                        <el-checkbox v-model="dataDetail.Head.virtual_flag" true-label="1" false-label="0" :disabled="dataDetail.Head.invoice_status != 0"></el-checkbox>
                                        {{ $t('getapi[3700]') }}
                                    </td>
                                </tr>
                                <tr>
                                    <td>{{ $t('getapi[1196]') }}</td>
                                    <td>
                                        <routejump :urlNo="26" v-show="dataDetail.Head.invoice_status == 0">
                                        <el-input  type="text" v-model="dataDetail.Head.vender_code"
                                                   readonly
                                                   class="mcolor"
                                                   size="mini"
                                        >
                                            <i  class="el-icon-edit el-input__icon" slot="suffix" @click="selectSupplier()"></i>
                                        </el-input>
                                        </routejump>
                                        <el-input v-model="dataDetail.Head.vender_code" size="mini"  v-show="dataDetail.Head.invoice_status != 0" :readonly="true" class="readO"></el-input>
                                    </td>
                                    <td>{{ $t('getapi[1197]') }}</td>
                                    <td colspan="3">
                                        <el-input  type="text" size="mini" v-model="dataDetail.Head.vender_name" :readonly="true" class="readO"
                                        ></el-input>
                                    </td>
                                    <td>{{ $t('getapi[3704]') }}</td>
                                    <td>
                                        <el-input  type="number" autocomplete="off" title="" @mousewheel.native.prevent size="mini" v-model="dataDetail.Head.tax_total_amount" :readonly="true" class="readO"
                                        ></el-input>
                                    </td>
                                    <td>{{ $t('getapi[3688]') }}</td>
                                    <td>
                                        <el-input  type="number" autocomplete="off" title="" @mousewheel.native.prevent size="mini" v-model="dataDetail.Head.remain_amount" :readonly="true" class="readO"
                                        ></el-input>
                                    </td>
                                </tr>
                                <tr>
                                    <td style="width:60px;min-width:60px">{{ $t('getapi[1225]') }}</td>
                                    <td style="width:120px;min-width:120px">
                                            <el-input v-model="dataDetail.Head.tax_rate" type="number" autocomplete="off" title="" @mousewheel.native.prevent size="mini" :readonly="true" class="readO"></el-input>
                                    </td>
                                    <td>{{ $t('getapi[3697]') }}</td>
                                    <td>
                                        <el-input  type="text" size="mini" v-model="dataDetail.Head.audit_period" :readonly="true" class="readO"
                                        ></el-input>
                                    </td>
                                    <td>{{ $t('getapi[3747]') }}</td>
                                    <td>
                                        <el-input  type="text" size="mini" :value="diffAmount" :readonly="true" class="readO"
                                        ></el-input>
                                    </td>
                                    <td>{{ $t('getapi[3725]') }}</td>
                                    <td>
                                        <el-input  type="text" size="mini" :value="netDiffAmount" :readonly="true" class="readO"
                                        ></el-input>
                                    </td>
                                    <td>{{ $t('getapi[3689]') }}</td>
                                    <td>
                                        <el-input  type="number" autocomplete="off" title="" @mousewheel.native.prevent size="mini" v-model="dataDetail.Head.vender_remain_amount" :readonly="true" class="readO"
                                        ></el-input>
                                    </td>

                                </tr>
                                <tr>
                                    <td>{{ $t('getapi[7222]') }}</td>
                                    <td colspan="9">
                                        <el-input v-model="dataDetail.Head.invoicenumlst" type="textarea" size="mini"></el-input>
                                    </td>
                                </tr>
                            </table>
                        </div>
                    </div>
                    <el-tabs :tab-position="'top'" type="" style="margin-top: 0px" @tab-click="selectInfo">
                        <el-tab-pane :label="$t('getapi[3726]')" name="0">
                            <div>
                                <el-button type="primary" size="mini" @click="showAddOrder('')" :disabled="!btn.batchadd">{{ $t('getapi[878]') }}
                                </el-button>
                                <el-button type="primary" size="mini" @click="batchDel" :disabled="!btn.batchdel">{{
                                    $t('getapi[1522]') }}
                                </el-button>
                            </div>
                            <el-table
                                    id="xdetilpane-0"
                                    :data="dataDetail.Lists"
                                    @selection-change="handleSelectionChangeDetail"
                                    :row-class-name="tableRowClassNameDetail"
                                    :highlight-current-row="true"
                                    :height="tableHeight - 300"
                                    header-row-class-name="headerclass"
                                    border
                                    size="mini"
                                    style="width: 100%; margin-top:3px"
                                    ref="singleTable1"
                            >
                                <el-table-column type="selection"></el-table-column>
                                <el-table-column show-overflow-tooltip prop="line_no" :label="$t('getapi[1425]')"></el-table-column>
                                <el-table-column show-overflow-tooltip prop="po_code" :label="$t('getapi[1710]')" width="120"></el-table-column>
                                <el-table-column prop="receive_order_no" :label="$t('getapi[463]')" width="150">
                                    <template scope="scope" v-if="dataDetail.Head.invoice_status == 0">
                                        <el-input
                                                v-model="scope.row.receive_order_no"
                                                type="text"
                                                readonly
                                                class="mcolor"
                                                size="mini"
                                        >
                                            <i  class="el-icon-edit el-input__icon" slot="suffix" @click="showAddOrder(scope)"></i>
                                        </el-input>
                                    </template>
                                </el-table-column>
                                <el-table-column show-overflow-tooltip prop="receive_order_line_no" :label="$t('getapi[2239]')"></el-table-column>
                                <el-table-column show-overflow-tooltip prop="part_code" :label="$t('getapi[112]')"></el-table-column>
                                <el-table-column show-overflow-tooltip prop="part_version" :label="$t('getapi[149]')"></el-table-column>
                                <el-table-column show-overflow-tooltip prop="category_first" :label="$t('getapi[169]')"></el-table-column>
                                <el-table-column show-overflow-tooltip prop="category_second" :label="$t('getapi[170]')"></el-table-column>
                                <el-table-column show-overflow-tooltip prop="category_third" :label="$t('getapi[171]')"></el-table-column>
                                <el-table-column show-overflow-tooltip prop="part_name" :label="$t('getapi[116]')"></el-table-column>
                                <el-table-column show-overflow-tooltip prop="part_model" :label="$t('getapi[124]')"></el-table-column>
                                <el-table-column show-overflow-tooltip prop="part_spec" :label="$t('getapi[125]')"></el-table-column>
                                <el-table-column show-overflow-tooltip prop="part_stuff" :label="$t('getapi[126]')"></el-table-column>
                                <el-table-column show-overflow-tooltip prop="already_invoice_qty" :label="$t('getapi[2004]')" align="right"></el-table-column>
                                <el-table-column prop="invoice_qty" :label="$t('getapi[1628]')" align="right">
                                    <template scope="scope" v-if="dataDetail.Head.invoice_status == 0">
                                        <el-input size="mini" type="number" autocomplete="off" title="" @mousewheel.native.prevent v-model="scope.row.invoice_qty" @change="changeDataDetailData(scope,1)"></el-input>
                                    </template>
                                </el-table-column>
                                <el-table-column show-overflow-tooltip prop="measure_unit" :label="$t('getapi[888]')"></el-table-column>
                                <el-table-column show-overflow-tooltip prop="vender_net_unit_price" :label="$t('getapi[2009]')" align="right" width="110"></el-table-column>
                                <el-table-column show-overflow-tooltip prop="vender_unit_price" :label="$t('getapi[2011]')" align="right" width="110"></el-table-column>
                                <el-table-column prop="vender_line_net_total_amount" :label="$t('getapi[2010]')" align="right" width="110">
                                    <template scope="scope" v-if="dataDetail.Head.invoice_status == 0">
                                        <el-input size="mini" type="number" autocomplete="off" title="" @mousewheel.native.prevent v-model="scope.row.vender_line_net_total_amount" @change="changeDataDetailData(scope,2)"
                                                  v-decimal-limit="$store.state.digitsetting.pur_amount_digit"></el-input>
                                    </template>
                                </el-table-column>
                                <el-table-column show-overflow-tooltip prop="net_unit_price" :label="$t('getapi[2007]')" align="right" width="110"></el-table-column>
                                <el-table-column show-overflow-tooltip prop="unit_price" :label="$t('getapi[3744]')" align="right" width="110"></el-table-column>
                                <el-table-column show-overflow-tooltip prop="line_net_total_amount" :label="$t('getapi[2008]')" align="right" width="110"></el-table-column>
                                <el-table-column prop="tax_amount" :label="$t('getapi[3732]')" align="right">
                                    <template scope="scope" v-if="dataDetail.Head.invoice_status == 0">
                                        <el-input size="mini" type="number" autocomplete="off" title="" @mousewheel.native.prevent v-model="scope.row.tax_amount" @change="changeDataDetailData(scope,3)"
                                                  v-decimal-limit="$store.state.digitsetting.pur_amount_digit"></el-input>
                                    </template>
                                </el-table-column>
                                <el-table-column show-overflow-tooltip prop="line_total_amount" :label="$t('getapi[3733]')" align="right"></el-table-column>
                                <el-table-column prop="receive_line_total_amount" :label="$t('getapi[3734]')" align="right" width="110">
                                    <template scope="scope">
                                        {{$processdata.mathRound2(scope.row.receive_line_total_amount)}}
                                    </template>
                                </el-table-column>
                                <el-table-column prop="diff_amount" :label="$t('getapi[3735]')" align="right" width="110">
                                    <template scope="scope">
                                        {{$processdata.mathRound2(scope.row.diff_amount)}}
                                    </template>
                                </el-table-column>
                                <el-table-column show-overflow-tooltip prop="order_line_total_amount" :label="$t('getapi[3736]')" align="right" width="120"></el-table-column>
                                <el-table-column prop="vender_net_amount_diff" :label="$t('getapi[3737]')" align="right" width="110">
                                    <template scope="scope">
                                        {{$processdata.mathRound2(scope.row.vender_net_amount_diff)}}
                                    </template>
                                </el-table-column>
                                <el-table-column prop="tax_amount_diff" :label="$t('getapi[8050]')" align="right" width="110">
                                    <template scope="scope">
                                        {{$processdata.mathRound2(scope.row.tax_amount_diff)}}
                                    </template>
                                </el-table-column>
                                <el-table-column prop="line_remark" :label="$t('getapi[4279]')">
                                    <template scope="scope" v-if="dataDetail.Head.invoice_status == 0">
                                        <el-input size="mini" v-model="scope.row.line_remark"></el-input>
                                    </template>
                                </el-table-column>
                            </el-table>
                        </el-tab-pane>
                        <el-tab-pane :label="$t('getapi[3739]')" name="1">
                            <table :height="tableHeight - 280">
                                <table>
                                    <tr>
                                        <td style="width:60px;min-width:60px">{{ $t('getapi[1228]') }}</td>
                                        <td style="width:120px;min-width:120px">
                                            <el-select filterable v-model="dataDetail.Head.balance_mode" size="mini">
                                                <el-option v-for="item in balanceMode" :key="item.Code" :label="item.Name"
                                                           :value="item.Code"></el-option>
                                            </el-select>
                                        </td>
                                        <td style="width:60px;min-width:60px">{{ $t('getapi[1221]') }}</td>
                                        <td style="width:120px;min-width:120px">
                                            <el-input v-model="dataDetail.Head.payment_period" type="number" autocomplete="off" title="" @mousewheel.native.prevent size="mini" :readonly="true" class="readO"></el-input>
                                        </td>
                                        <td style="width:60px;min-width:60px">{{ $t('getapi[1249]') }}</td>
                                        <td style="width:120px;min-width:120px">
                                            <el-input v-model="dataDetail.Head.tax_code" size="mini" :readonly="true" class="readO"></el-input>
                                        </td>
                                        <!-- <td style="width:60px;min-width:60px">{{ $t('getapi[1225]') }}</td>
                                        <td style="width:120px;min-width:120px">
                                            <el-input v-model="dataDetail.Head.tax_rate" type="number" autocomplete="off" title="" @mousewheel.native.prevent size="mini" :readonly="true" class="readO"></el-input>
                                        </td> -->
                                    </tr>
                                    <tr>
                                        <td>{{ $t('getapi[3740]') }}</td>
                                        <td>
                                            <el-input v-model="dataDetail.Head.currency_code" size="mini" :readonly="true" class="readO"></el-input>
                                        </td>
                                        <td>{{ $t('getapi[1219]') }}</td>
                                        <td>
                                            <el-input v-model="dataDetail.Head.bank_account_name" size="mini" :readonly="true" class="readO"></el-input>
                                        </td>
                                        <td>{{ $t('getapi[1220]') }}</td>
                                        <td colspan="3">
                                            <el-input v-model="dataDetail.Head.bank_account_number" size="mini" :readonly="true" class="readO"></el-input>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>{{ $t('getapi[1224]') }}</td>
                                        <td>
                                            <el-input v-model="dataDetail.Head.tax_number" size="mini" :readonly="true" class="readO"></el-input>
                                        </td>
                                    </tr>
                                </table>
                            </table>
                        </el-tab-pane>
                        <el-tab-pane :label="$t('getapi[3741]')" name="2">
                            <div>
                                <el-button type="primary" size="mini" @click="selectChargeName('')" :disabled="!btn.batchaddcost">{{$t('getapi[6708]')}}
                                </el-button>
                                <el-button type="primary" size="mini" @click="addOtherCostList" :disabled="!btn.batchaddcost">{{$t('getapi[6467]')}}
                                </el-button>
                                <el-button type="primary" size="mini" @click="batchDelOtherCostList" :disabled="!btn.batchdelcost">{{
                                    $t('getapi[4097]') }}
                                </el-button>
                            </div>
                            <el-table
                                    id="xdetilpane-2"
                                    :data="dataDetail.OtherCostList"
                                      :highlight-current-row="true"
                                      show-overflow-tooltip="true"
                                      :height="tableHeight - 300"
                                      header-row-class-name="headerclass"
                                      @selection-change="handleSelectionChangeDetailCost"
                                      :row-class-name="tableRowClassNameDetailCost" border stripe
                                      size="mini" style="width: 100%;margin-top:3px"
                                      ref="singleTable2">
                                <el-table-column type="selection"></el-table-column>
                                <el-table-column show-overflow-tooltip prop="line_no" :label="$t('getapi[1425]')"></el-table-column>
                                <el-table-column prop="charge_name" :label="$t('getapi[2728]')">
                                    <template scope="scope" v-if="dataDetail.Head.invoice_status == 0">
                                        <el-input
                                                v-model="scope.row.charge_name"
                                                type="text"
                                                size="mini"
                                        >
                                            <i  class="el-icon-edit el-input__icon"  slot="suffix" @click="selectChargeName(scope)"></i>

                                        </el-input>
                                    </template>
                                </el-table-column>
                                <el-table-column prop="charge_qty" :label="$t('getapi[3101]')">
                                    <template scope="scope" v-if="dataDetail.Head.invoice_status == 0">
                                        <el-input size="mini" type="number" autocomplete="off" title="" @mousewheel.native.prevent v-model="scope.row.charge_qty" @change="changechargedata(scope)"></el-input>
                                    </template>
                                </el-table-column>
                                <el-table-column prop="net_unit_price" :label="$t('getapi[3714]')">
                                    <template scope="scope" v-if="dataDetail.Head.invoice_status == 0">
                                        <el-input size="mini" type="number" autocomplete="off" title="" @mousewheel.native.prevent v-model="scope.row.net_unit_price" @change="changechargedata(scope)"
                                                  v-decimal-limit="$store.state.digitsetting.pur_price_digit"></el-input>
                                    </template>
                                </el-table-column>
                                <el-table-column prop="unit_price" :label="$t('getapi[3806]')">
                                    <template scope="scope" v-if="dataDetail.Head.invoice_status == 0">
                                        <el-input size="mini" type="number" autocomplete="off" title="" @mousewheel.native.prevent v-model="scope.row.unit_price" @change="changechargedata(scope)"
                                                  v-decimal-limit="$store.state.digitsetting.pur_price_digit"></el-input>
                                    </template>
                                </el-table-column>
                                <el-table-column show-overflow-tooltip prop="net_total_amount" :label="$t('getapi[2010]')"></el-table-column>
                                <el-table-column show-overflow-tooltip prop="total_amount" :label="$t('getapi[2012]')"></el-table-column>
                                <el-table-column show-overflow-tooltip prop="base_net_unit_price" :label="$t('getapi[2007]')"></el-table-column>
                                <el-table-column show-overflow-tooltip prop="base_unit_price" :label="$t('getapi[3744]')"></el-table-column>
                                <el-table-column show-overflow-tooltip prop="base_net_total_amount" :label="$t('getapi[2008]')"></el-table-column>
                                <el-table-column show-overflow-tooltip prop="base_total_amount" :label="$t('getapi[3745]')"></el-table-column>
                            </el-table>
                        </el-tab-pane>
                        <el-tab-pane :label="$t('getapi[7227]')" name="3">
                            <table :height="tableHeight - 280" v-if="!showpdf">
                                <!-- <div style="height:100%;overflow-y: auto" class="demo-image__lazy">
                                    <el-image v-for="data in dataDetail.ImgList" :key="data.invoice_no" :src="data.HttpFilePath"></el-image>
                                </div> -->
                                <div style="display: flex">
                                    <el-upload
                                            list-type="picture-card"
                                            action=""
                                            :file-list="fileList">
                                        <i slot="default" class="el-icon-plus"></i>
                                        <div slot="file" slot-scope="{file}">
                                            <img
                                                    class="el-upload-list__item-thumbnail"
                                                    :src="file.url" alt=""
                                            >
                                            <span class="el-upload-list__item-actions">
                                            <span
                                                    class="el-upload-list__item-preview"
                                                    @click="handlePictureCardPreview(file)"
                                            >
                                              <i class="el-icon-zoom-in"></i>
                                            </span>
                                          </span>
                                        </div>
                                    </el-upload>
                                    <el-dialog v-dialogDrag :visible.sync="dialogVisible">
                                        <img width="100%" :src="dialogImageUrl" alt="">
                                    </el-dialog>
                                </div>
                            </table>
                            <div :height="tableHeight - 280" class="pdf" v-if="showpdf">
                                <iframe v-bind:src="src" width="100%" :height="tableHeight - 280"></iframe>
                            </div>
                        </el-tab-pane>
                    </el-tabs>
                    <div style="width:720px">
                        <table>
                            <tr>
                                <td style="width:100px;min-width:100px">{{ $t('getapi[1890]') }}</td>
                                <td style="width:140px;min-width:140px">
                                    <el-input v-model="dataDetail.Head.create_person" size="mini" :readonly="true" class="readO"></el-input>
                                </td>
                                <td style="width:100px;min-width:100px">{{ $t('getapi[4043]') }}</td>
                                <td style="width:140px;min-width:140px">
                                    <el-input v-model="dataDetail.Head.audit_person" size="mini" :readonly="true" class="readO"></el-input>
                                </td>
                                <td style="width:100px;min-width:100px">{{ $t('getapi[3749]') }}</td>
                                <td style="width:140px;min-width:140px">
                                    <el-input v-model="dataDetail.Head.net_total_amount" type="number" autocomplete="off" title="" @mousewheel.native.prevent size="mini" :readonly="true" class="readO"></el-input>
                                </td>
                            </tr>
                            <tr>
                                <td>{{ $t('getapi[1859]') }}</td>
                                <td>
                                    <el-date-picker v-model="dataDetail.Head.create_date" type="date" size="mini"
                                                    style="width:100%" :readonly="true" class="readO"></el-date-picker>
                                </td>
                                <td>{{ $t('getapi[3692]') }}</td>
                                <td>
                                    <el-date-picker v-model="dataDetail.Head.audit_date" type="date" size="mini"
                                                    style="width:100%" :readonly="true" class="readO"></el-date-picker>
                                </td>
                                <td>{{ $t('getapi[3746]') }}</td>
                                <td>
                                    <el-input v-model="dataDetail.Head.vender_net_total_amount" type="number" autocomplete="off" title="" @mousewheel.native.prevent size="mini" :readonly="true" class="readO"></el-input>
                                </td>
                            </tr>
                        </table>
                    </div>
                </div>
                <div v-if="negative_flag != 0">
                    <div>
                        <div class="btnnowrap">
                           <!-- <el-button type="primary" size="mini" @click="batchImport">{{
                                $t('getapi[412]') }}
                            </el-button>-->
                            <el-button type="primary" size="mini" @click="beforeAuditPurInvoice" :disabled="!btn.auditred  || addoredit == 0">{{
                                $t('getapi[3607]') }}
                            </el-button>
                            <el-button type="primary" size="mini" @click="beforeRAuditPurInvoiceRed" :disabled="!btn.rauditred">{{
                                $t('getapi[1334]') }}
                            </el-button>
                            <el-button type="primary" size="mini" @click="balancePurInvoiceRed" :disabled="!btn.balancered">{{
                                $t('getapi[1868]') }}
                            </el-button>
                            <el-button type="primary" size="mini" @click="rBalancePurInvoiceRed" :disabled="!btn.rbalancered">{{
                                $t('getapi[1869]') }}
                            </el-button>
                            <el-button type="primary" size="mini" @click="beforeSetRatePurInvoice" :disabled="!btn.setratered">{{
                                $t('getapi[3878]') }}
                            </el-button>
                            <el-button type="primary" size="mini" @click="beforeSetTaxRatePurInvoice" :disabled="!btn.settaxratered">
                                {{ $t('getapi[7224]')}}
                            </el-button>
                            <el-button type="primary" size="mini" @click="beforeSetChangeTaxRatePurInvoice" :disabled="!btn.settaxratebackred">{{$t('getapi[7225]')}}
                            </el-button>
                            <el-button type="primary" size="mini" @click="beforeChangeAuditDate" :disabled="!btn.editauditdatered">{{$t('getapi[3722]')}}
                            </el-button>
                            <el-button type="primary" size="mini" @click="beforeChangePayDate" :disabled="!btn.fkrqred">{{$t('getapi[7226]')}}
                            </el-button>
                            <el-radio v-model="billmode" label="1" style="margin-left: 8px">{{$t('getapi[3978]')}}</el-radio>
                            <el-radio v-model="billmode" label="2">{{$t('getapi[3979]')}}</el-radio>
                        </div>
                        <table>
                            <tr>
                                <td style="width:60px;min-width:60px">{{ $t('getapi[2992]') }}</td>
                                <td style="width:160px;min-width:160px">
                                    <el-input  type="text" size="mini" v-model="dataDetailRed.Head.invoice_no" class="mcolor" v-show="dataDetailRed.Head.invoice_status == 0 && addoredit == 0"
                                    ></el-input>
                                    <el-input type="text" size="mini" v-model="dataDetailRed.Head.invoice_no" :readonly="true" class="readO" v-show="dataDetailRed.Head.invoice_status != 0 || addoredit != 0"></el-input>
                                </td>
                                <td style="width:60px;min-width:60px">{{ $t('getapi[3682]') }}</td>
                                <td style="width:160px;min-width:160px">
                                    <el-select filterable v-model="dataDetailRed.Head.invoice_type_code" size="mini" v-show="dataDetailRed.Head.invoice_status == 0">
                                        <el-option v-for="item in invoiceType" :key="item.Code" :label="item.Name"
                                                   :value="item.Code"></el-option>
                                    </el-select>
                                </td>
                                <td style="width:60px;min-width:60px">{{ $t('getapi[3686]') }}</td>
                                <td style="width:160px;min-width:160px">
                                    <el-date-picker v-model="dataDetailRed.Head.payment_date" type="date" size="mini"
                                                    style="width:100%" :readonly="true" class="readO"></el-date-picker>
                                </td>
                                <td style="width:60px;min-width:60px">{{ $t('getapi[3694]') }}</td>
                                <td style="width:160px;min-width:160px">
                                    <el-input  type="text" size="mini" :value="expInvoiceStatus(dataDetailRed.Head.invoice_status)" :readonly="true" class="readO"
                                    ></el-input>
                                </td>
                                <td style="width:60px;min-width:60px">{{ $t('getapi[3287]') }}</td>
                                <td style="width:160px;min-width:160px">
                                    <el-input  type="text" size="mini" v-model="dataDetailRed.Head.exchange_rate" :readonly="true" class="readO"
                                    ></el-input>
                                </td>
                                <td style="width:80px;min-width:80px">
                                    {{ $t('getapi[2096]') }}
                                    <el-checkbox v-model="dataDetailRed.Head.negative_flag" true-label="1" false-label="0" :disabled="true"></el-checkbox>
                                </td>
                            </tr>
                            <tr>
                                <td>{{ $t('getapi[3681]') }}</td>
                                <td>
                                    <el-input  type="text" size="mini" v-model="dataDetailRed.Head.invoice_code" :readonly="dataDetailRed.Head.invoice_status != 0" :class="{'readO':dataDetailRed.Head.invoice_status != 0}"
                                    ></el-input>
                                </td>
                                <td>{{ $t('getapi[3683]') }}</td>
                                <td>
                                    <el-date-picker v-model="dataDetailRed.Head.invoice_date" type="date" size="mini"
                                                    style="width:100%" :readonly="dataDetailRed.Head.invoice_status != 0" :class="{'readO':dataDetailRed.Head.invoice_status != 0}"></el-date-picker>
                                </td>
                                <td>{{ $t('getapi[1976]') }}</td>
                                <td>
                                    <el-select filterable v-model="dataDetailRed.Head.order_type_code" size="mini" :disabled="true">
                                        <el-option v-for="item in invoiceOrderType" :key="item.Code" :label="item.Name"
                                                   :value="item.Code"></el-option>
                                    </el-select>
                                </td>
                                <td>{{ $t('getapi[3748]') }}</td>
                                <td >
                                    <el-input  type="number" autocomplete="off" title="" @mousewheel.native.prevent size="mini" :value="dataDetailRed.Head.total_amount" :readonly="true" class="readO"
                                    ></el-input>
                                </td>
                                <td>{{ $t('getapi[3689]') }}</td>
                                <td>
                                    <el-input  type="number" autocomplete="off" title="" @mousewheel.native.prevent size="mini" v-model="dataDetailRed.Head.vender_remain_amount" :readonly="true" class="readO"
                                    ></el-input>
                                </td>
                            </tr>
                            <tr>
                                <td>{{ $t('getapi[1196]') }}</td>
                                <td>
                                    <routejump :urlNo="26" v-show="dataDetailRed.Head.invoice_status == 0">
                                    <el-input  type="text" v-model="dataDetailRed.Head.vender_code"
                                               readonly
                                               class="mcolor"
                                               size="mini"
                                    >
                                        <i  class="el-icon-edit el-input__icon" slot="suffix" @click="selectSupplier()"></i>
                                    </el-input>
                                    </routejump>
                                    <el-input type="text" v-model="dataDetailRed.Head.vender_code" :readonly="true" class="readO" v-show="dataDetailRed.Head.invoice_status != 0"></el-input>
                                </td>
                                <td>{{ $t('getapi[1197]') }}</td>
                                <td colspan="3">
                                    <el-input  type="text" size="mini" v-model="dataDetailRed.Head.vender_name" :readonly="true" class="readO"
                                    ></el-input>
                                </td>
                                <td>{{ $t('getapi[3704]') }}</td>
                                <td >
                                    <el-input  type="number" autocomplete="off" title="" @mousewheel.native.prevent size="mini" v-model="dataDetailRed.Head.tax_total_amount" :readonly="true" class="readO"
                                    ></el-input>
                                </td>
                                <td>{{ $t('getapi[3688]') }}</td>
                                <td>
                                    <el-input  type="number" autocomplete="off" title="" @mousewheel.native.prevent size="mini" v-model="dataDetailRed.Head.remain_amount" :readonly="true" class="readO"
                                    ></el-input>
                                </td>
                            </tr>
                            <tr>
                                 <td style="width:60px;min-width:60px">{{ $t('getapi[1225]') }}</td>
                                <td style="width:120px;min-width:120px">
                                    <el-input v-model="dataDetailRed.Head.tax_rate" type="number" autocomplete="off" title="" @mousewheel.native.prevent size="mini" :readonly="true" class="readO"></el-input>
                                </td>
                                <td>{{ $t('getapi[3697]') }}</td>
                                <td>
                                    <el-input  type="text" size="mini" v-model="dataDetailRed.Head.audit_period" :readonly="true" class="readO"
                                    ></el-input>
                                </td>
                                <td colspan="4"></td>
                                <td colspan="2">
                                    <el-checkbox v-model="dataDetailRed.Head.virtual_flag" true-label="1" false-label="0" :disabled="dataDetailRed.Head.invoice_status != 0"></el-checkbox>
                                    {{ $t('getapi[3700]') }}
                                </td>
                            </tr>
                            <tr>
                                <td>{{ $t('getapi[7222]') }}</td>
                                <td colspan="9">
                                    <el-input v-model="dataDetailRed.Head.invoicenumlst" type="textarea" size="mini"></el-input>
                                </td>
                            </tr>
                        </table>
                    </div>
                    <el-tabs :tab-position="'top'" type="" style="margin-top: 0px" @tab-click="selectInfo">
                        <el-tab-pane :label="$t('getapi[3726]')" name="10">
                            <div>
                                <el-button type="primary" size="mini" @click="showAddOrderRed('')" :disabled="!btn.batchaddred">{{ $t('getapi[878]') }}
                                </el-button>
                                <el-button type="primary" size="mini" @click="batchDelRed" :disabled="!btn.batchdelred">{{
                                    $t('getapi[1522]') }}
                                </el-button>
                            </div>
                            <el-table
                                    id="xdetilpane-10"
                                    :data="dataDetailRed.Lists"
                                    @selection-change="handleSelectionChangeDetailRed"
                                    :row-class-name="tableRowClassNameDetailRed"
                                    :highlight-current-row="true"
                                    :height="tableHeight - 400"
                                    header-row-class-name="headerclass"
                                    border
                                    size="mini"
                                    style="width: 100%; margin-top:5px"
                                    ref="singleTable3"
                            >
                                <el-table-column type="selection"></el-table-column>
                                <el-table-column show-overflow-tooltip prop="line_no" :label="$t('getapi[1425]')"></el-table-column>
                                <el-table-column show-overflow-tooltip prop="po_code" :label="$t('getapi[1710]')" width="120"></el-table-column>
                                <el-table-column prop="receive_order_no" :label="$t('getapi[7228]')" width="150">
                                    <template scope="scope" v-if="dataDetailRed.Head.invoice_status == 0">
                                        <el-input
                                                v-model="scope.row.receive_order_no"
                                                type="text"
                                                readonly
                                                class="mcolor"
                                                size="mini"
                                        >
                                            <i  class="el-icon-edit el-input__icon" slot="suffix" @click="showAddOrder(scope)"></i>
                                        </el-input>
                                    </template>
                                </el-table-column>
                                <el-table-column show-overflow-tooltip prop="receive_order_line_no" :label="$t('getapi[7229]')"></el-table-column>
                                <el-table-column show-overflow-tooltip prop="part_code" :label="$t('getapi[112]')"></el-table-column>
                                <el-table-column show-overflow-tooltip prop="part_version" :label="$t('getapi[149]')"></el-table-column>
                                <el-table-column show-overflow-tooltip prop="part_name" :label="$t('getapi[116]')"></el-table-column>
                                <el-table-column show-overflow-tooltip prop="part_model" :label="$t('getapi[124]')"></el-table-column>
                                <el-table-column show-overflow-tooltip prop="part_spec" :label="$t('getapi[125]')"></el-table-column>
                                <el-table-column show-overflow-tooltip prop="already_invoice_qty" :label="$t('getapi[2004]')" align="right"></el-table-column>
                                <el-table-column prop="invoice_qty" :label="$t('getapi[1628]')" align="right">
                                    <template scope="scope" v-if="dataDetailRed.Head.invoice_status == 0">
                                        <el-input size="mini" type="number" autocomplete="off" title="" @mousewheel.native.prevent v-model="scope.row.invoice_qty" @change="changeDataDetailRedData(scope, 1)"></el-input>
                                    </template>
                                </el-table-column>
                                <el-table-column show-overflow-tooltip prop="measure_unit" :label="$t('getapi[888]')"></el-table-column>
                                <el-table-column prop="vender_net_unit_price" :label="$t('getapi[2009]')" align="right" width="110">
                                    <template scope="scope">
                                        {{$processdata.mathRound6(scope.row.vender_net_unit_price)}}
                                    </template>
                                </el-table-column>
                                <el-table-column prop="vender_unit_price" :label="$t('getapi[2011]')" align="right" width="110">
                                    <template scope="scope">
                                        {{$processdata.mathRound6(scope.row.vender_unit_price)}}
                                    </template>
                                </el-table-column>
                                <el-table-column prop="vender_line_net_total_amount" :label="$t('getapi[2010]')" align="right" width="110">
                                    <template scope="scope" v-if="dataDetailRed.Head.invoice_status == 0">
                                        <el-input size="mini" type="number" autocomplete="off" title="" @mousewheel.native.prevent v-model="scope.row.vender_line_net_total_amount" @change="changeDataDetailRedData(scope, 2)"
                                                  v-decimal-limit="$store.state.digitsetting.pur_amount_digit"></el-input>
                                    </template>
                                </el-table-column>
                                <el-table-column prop="net_unit_price" :label="$t('getapi[2007]')" align="right" width="110">
                                    <template scope="scope">
                                        {{$processdata.mathRound6(scope.row.net_unit_price)}}
                                    </template>
                                </el-table-column>
                                <el-table-column prop="unit_price" :label="$t('getapi[3744]')" align="right" width="110">
                                    <template scope="scope">
                                        {{$processdata.mathRound6(scope.row.unit_price)}}
                                    </template>
                                </el-table-column>
                                <el-table-column show-overflow-tooltip prop="line_net_total_amount" :label="$t('getapi[2008]')" align="right" width="110"></el-table-column>
                                <el-table-column prop="tax_amount" :label="$t('getapi[3732]')" align="right">
                                    <template scope="scope" v-if="dataDetailRed.Head.invoice_status == 0">
                                        <el-input size="mini" type="number" autocomplete="off" title="" @mousewheel.native.prevent v-model="scope.row.tax_amount" @change="changeDataDetailRedData(scope, 3)"
                                                  v-decimal-limit="$store.state.digitsetting.pur_amount_digit"></el-input>
                                    </template>
                                </el-table-column>
                                <el-table-column show-overflow-tooltip prop="line_total_amount" :label="$t('getapi[3733]')" align="right"></el-table-column>
                                <el-table-column prop="line_remark" :label="$t('getapi[4279]')">
                                    <template scope="scope" v-if="dataDetailRed.Head.invoice_status == 0">
                                        <el-input size="mini" v-model="scope.row.line_remark"></el-input>
                                    </template>
                                </el-table-column>
                            </el-table>
                        </el-tab-pane>
                        <el-tab-pane :label="$t('getapi[3739]')" name="11">
                            <table :height="tableHeight - 380">
                                <table>
                                    <tr>
                                        <td style="width:60px;min-width:60px">{{ $t('getapi[1228]') }}</td>
                                        <td style="width:120px;min-width:120px">
                                            <el-select filterable v-model="dataDetailRed.Head.balance_mode" size="mini">
                                                <el-option v-for="item in balanceMode" :key="item.Code" :label="item.Name"
                                                           :value="item.Code"></el-option>
                                            </el-select>
                                        </td>
                                        <td style="width:60px;min-width:60px">{{ $t('getapi[1221]') }}</td>
                                        <td style="width:120px;min-width:120px">
                                            <el-input v-model="dataDetailRed.Head.payment_period" type="number" autocomplete="off" title="" @mousewheel.native.prevent size="mini" :readonly="true" class="readO"></el-input>
                                        </td>
                                        <td style="width:60px;min-width:60px">{{ $t('getapi[1249]') }}</td>
                                        <td style="width:120px;min-width:120px">
                                            <el-input v-model="dataDetailRed.Head.tax_code" size="mini" :readonly="true" class="readO"></el-input>
                                        </td>
                                        <!-- <td style="width:60px;min-width:60px">{{ $t('getapi[1225]') }}</td>
                                        <td style="width:120px;min-width:120px">
                                            <el-input v-model="dataDetailRed.Head.tax_rate" type="number" autocomplete="off" title="" @mousewheel.native.prevent size="mini" :readonly="true" class="readO"></el-input>
                                        </td> -->
                                    </tr>
                                    <tr>
                                        <td>{{ $t('getapi[3740]') }}</td>
                                        <td>
                                            <el-input v-model="dataDetailRed.Head.currency_code" size="mini" :readonly="true" class="readO"></el-input>
                                        </td>
                                        <td>{{ $t('getapi[1219]') }}</td>
                                        <td>
                                            <el-input v-model="dataDetailRed.Head.bank_account_name" size="mini" :readonly="true" class="readO"></el-input>
                                        </td>
                                        <td>{{ $t('getapi[1220]') }}</td>
                                        <td colspan="3">
                                            <el-input v-model="dataDetailRed.Head.bank_account_number" size="mini" :readonly="true" class="readO"></el-input>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>{{ $t('getapi[1224]') }}</td>
                                        <td>
                                            <el-input v-model="dataDetailRed.Head.tax_number" size="mini" :readonly="true" class="readO"></el-input>
                                        </td>
                                    </tr>
                                </table>
                            </table>
                        </el-tab-pane>
                        <el-tab-pane :label="$t('getapi[7227]')" name="12">
                            <table :height="tableHeight - 380" v-if="!showpdf">
                               <!-- <div style="height:100%;overflow-y: auto" class="demo-image__lazy">
                                    <el-image v-for="data in dataDetailRed.ImgList" :key="data.invoice_no" :src="data.HttpFilePath"></el-image>
                                </div>-->
                                <div style="display: flex">
                                    <el-upload
                                            list-type="picture-card"
                                            action=""
                                            :file-list="fileList">
                                        <i slot="default" class="el-icon-plus"></i>
                                        <div slot="file" slot-scope="{file}">
                                            <img
                                                    class="el-upload-list__item-thumbnail"
                                                    :src="file.url" alt=""
                                            >
                                            <span class="el-upload-list__item-actions">
                                            <span
                                                    class="el-upload-list__item-preview"
                                                    @click="handlePictureCardPreview(file)"
                                            >
                                              <i class="el-icon-zoom-in"></i>
                                            </span>
                                            <span
                                                    v-if="!disabled"
                                                    class="el-upload-list__item-delete"
                                                    @click="handleRemove(file)"
                                            >
                                              <i class="el-icon-delete"></i>
                                            </span>
                                          </span>
                                        </div>
                                    </el-upload>
                                    <el-dialog v-dialogDrag :visible.sync="dialogVisible">
                                        <img width="100%" :src="dialogImageUrl" alt="">
                                    </el-dialog>
                                </div>
                            </table>
                            <div :height="tableHeight - 380" class="pdf" v-if="showpdf">
                                <iframe v-bind:src="src" width="100%" :height="tableHeight - 380"></iframe>
                            </div>
                        </el-tab-pane>
                    </el-tabs>
                    <div>
                        <table>
                            <tr>
                                <td style="width:100px;min-width:100px">{{ $t('getapi[1890]') }}</td>
                                <td style="width:140px;min-width:140px">
                                    <el-input v-model="dataDetailRed.Head.create_person" size="mini" :readonly="true" class="readO"></el-input>
                                </td>
                                <td style="width:100px;min-width:100px">{{ $t('getapi[4043]') }}</td>
                                <td style="width:140px;min-width:140px">
                                    <el-input v-model="dataDetailRed.Head.audit_person" size="mini" :readonly="true" class="readO"></el-input>
                                </td>
                                <td style="width:100px;min-width:100px">{{ $t('getapi[3749]') }}</td>
                                <td style="width:140px;min-width:140px">
                                    <el-input v-model="dataDetailRed.Head.net_total_amount" type="number" autocomplete="off" title="" @mousewheel.native.prevent size="mini" :readonly="true" class="readO"></el-input>
                                </td>
                            </tr>
                            <tr>
                                <td>{{ $t('getapi[1859]') }}</td>
                                <td>
                                    <el-date-picker v-model="dataDetailRed.Head.create_date" type="date" size="mini"
                                                    style="width:100%" :readonly="true" class="readO"></el-date-picker>
                                </td>
                                <td>{{ $t('getapi[3692]') }}</td>
                                <td>
                                    <el-date-picker v-model="dataDetailRed.Head.audit_date" type="date" size="mini"
                                                    style="width:100%" :readonly="true" class="readO"></el-date-picker>
                                </td>
                                <td>{{ $t('getapi[3746]') }}</td>
                                <td>
                                    <el-input v-model="dataDetailRed.Head.vender_net_total_amount" type="number" autocomplete="off" title="" @mousewheel.native.prevent size="mini" :readonly="true" class="readO"></el-input>
                                </td>
                            </tr>
                        </table>
                    </div>
                </div>
            </li>
        </ul>
        <el-row class="page">
            <el-col :span="18">
                <el-pagination
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :page-sizes="[100, 200, 300, 400]"
                        :page-size="pageSize"
                        :pager-count="5"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="total"
                ></el-pagination>
            </el-col>
            <el-col :span="6">
                <div style="text-align: right;line-height:30px;color: #545c64;font-size: 95%;">{{$t('getapi[7980]')}}:{{ DbTbNames }}</div>
            </el-col>
        </el-row>

        <el-dialog v-dialogDrag :visible.sync="visUpdateUserStatus" :title="$t('getapi[7223]')" width="25%" :close-on-click-modal="false" >
            <el-input v-model="userStatus" type="textarea"></el-input>
            <span slot="footer" class="dialog-footer">
				<el-button @click="visUpdateUserStatus = false">{{ $t('getapi[2054]') }}</el-button>
				<el-button type="primary" @click="updateUserStatus">{{$t('getapi[1146]')}}</el-button>
			</span>
        </el-dialog>

        <el-dialog v-dialogDrag :visible.sync="visAddType" width="25%" :close-on-click-modal="false" >
            <el-radio v-model="negativeflag" label="0">{{$t('getapi[7230]')}}</el-radio>
            <el-radio v-model="negativeflag" label="1">{{$t('getapi[7231]')}}</el-radio>

            <span slot="footer" class="dialog-footer">
				<el-button @click="visAddType = false">{{ $t('getapi[2054]') }}</el-button>
				<el-button type="primary" @click="confirmAdd">{{ $t('getapi[4943]') }}</el-button>
			</span>
        </el-dialog>

        <el-dialog v-dialogDrag :visible.sync="auditCheckVisiable" width="25%" :close-on-click-modal="false" >
            {{ $t('getapi[7232]') }}
            <el-date-picker
                    v-model="auditCheckData.YearMonth"
                    :start-placeholder="auditCheckData.DBYM"
                    :end-placeholder="auditCheckData.SysYM"
                    :picker-options="pickerOptionsInterval"
                    type="month"
                    >
            </el-date-picker>
            <el-input :value="$t('getapi[7233]') + auditCheckData.DBYM + $t('getapi[7234]') + auditCheckData.SysYM" type="textarea" style="margin-top: 8px"></el-input>

            <span slot="footer" class="dialog-footer">
				<el-button @click="auditCheckFalse">{{$t('getapi[2053]')}}</el-button>
				<el-button type="primary" @click="auditCheckTrue">{{$t('getapi[2052]')}}</el-button>
			</span>
        </el-dialog>

        <el-dialog v-dialogDrag :visible.sync="visRate" :title="$t('getapi[3878]')" width="15%" :close-on-click-modal="false" >
            <tr><td>{{$t('getapi[3287]')}}</td><td><el-input v-model="exchange_rate" type="number" autocomplete="off" title="" @mousewheel.native.prevent size="mini"></el-input></td></tr>

            <span slot="footer" class="dialog-footer">
				<el-button size="mini" @click="visRate = false">{{ $t('getapi[2054]') }}</el-button>
				<el-button size="mini" type="primary" @click="setRatePurInvoice">{{ $t('getapi[1146]') }}</el-button>
			</span>
        </el-dialog>

        <el-dialog v-dialogDrag :visible.sync="visTaxRate" :title="$t('getapi[7224]')" width="15%" :close-on-click-modal="false" >
            <tr><td>{{$t('getapi[1225]')}}</td><td><el-input v-model="tax_rate" type="number" autocomplete="off" title="" @mousewheel.native.prevent size="mini"></el-input></td></tr>

            <span slot="footer" class="dialog-footer">
				<el-button size="mini" @click="visTaxRate = false">{{ $t('getapi[2054]') }}</el-button>
				<el-button size="mini" type="primary" @click="setTaxRatePurInvoice">{{$t('getapi[1146]') }}</el-button>
			</span>
        </el-dialog>

        <el-dialog v-dialogDrag :visible.sync="visChangeAuditDate" :title="$t('getapi[7235]')" width="15%" :close-on-click-modal="false" >
            <div style="display: flex;">
                <el-date-picker
                        v-model="audit_period">
                </el-date-picker>
                <el-button size="mini" type="primary" @click="changeAuditDate">{{$t('getapi[2092]')}}</el-button>
            </div>
            <div style="height:10px"></div>
        </el-dialog>

        <el-dialog v-dialogDrag :visible.sync="visChangePayDate" :title="$t('getapi[7236]')" width="15%" :close-on-click-modal="false" >
            <span>{{$t('getapi[3836]')}}{{dataDetail.Head.invoice_no}}</span>
            <div style="display: flex;margin-top: 15px">
                <el-date-picker
                        v-model="payDate">
                </el-date-picker>
                <el-button size="mini" type="primary" @click="changePayDate">{{$t('getapi[3961]')}}</el-button>
            </div>
            <div style="height:10px"></div>
        </el-dialog>

        <el-dialog v-dialogDrag :visible.sync="visChangeTaxRate" :title="$t('getapi[7237]')" width="15%" :close-on-click-modal="false" >
            <div style="text-align: center">
            <span style="color:red">{{$t('getapi[7238]')}}</span>
            <br/>
            <span style="color:red">{{$t('getapi[7239]')}}</span>
            </div>
            <tr><td>{{$t('getapi[7240]')}}</td><td><el-input v-model="old_tax_rate" type="number" autocomplete="off" title="" @mousewheel.native.prevent size="mini"></el-input></td>%</tr>

            <span slot="footer" class="dialog-footer">
				<el-button size="mini" @click="visChangeTaxRate = false">{{ $t('getapi[2054]') }}</el-button>
				<el-button size="mini" type="primary" @click="setChangeTaxRatePurInvoice">{{$t('getapi[1146]')}}</el-button>
			</span>
        </el-dialog>

        <serce :isVisible="isVisible" queryData="PurInvoiceListViewInfo" ref="ser" @getser="serclick"></serce>
        <ctable :isVisible="false" :title="$t('getapi[3676]')" queryData="PurInvoiceListViewInfo" tabNo="0" ref="ctab"
                @getctab="sortclick"></ctable>
        <!--选择供应商-->
        <selector :isVisible="false" :isBatch=false :isSplitPage=true :postUrl="'/Pur/Invoice/GetPurInvoiceSupplyList'" @callback="getsupplier" ref="supplier"></selector>
        <!--发票明细-->
        <selectorvxe :isVisible="false" :isBatch=true :postUrl="'/Pur/Invoice/GetPurReceiveInListByVendCode'" @callback="getorder" ref="order"></selectorvxe>
        <selector :isVisible="false" :isBatch=false :isSplitPage=false :postUrl="'/Pur/Invoice/GetPurReceiveInListByVendCode'" @callback="getorder" ref="ordersingle"></selector>
        <!--发票明细-红字-->
        <selector :isVisible="false" :isBatch=true :isSplitPage=false :postUrl="'/Pur/Invoice/GetPurReturnListByVendCode'" @callback="getorderred" ref="orderred"></selector>
        <selector :isVisible="false" :isBatch=false :isSplitPage=false :postUrl="'/Pur/Invoice/GetPurReturnListByVendCode'" @callback="getorderred" ref="ordersinglered"></selector>
        <!--费用项名称-->
        <selector :isVisible="false" :isBatch=true :isSplitPage=false :postUrl="'Pur/Invoice/GetLogInfoListByVendCode'" @callback="getChargeName" ref="charge"></selector>
        <selector :isVisible="false" :isBatch=false :isSplitPage=false :postUrl="'Pur/Invoice/GetLogInfoListByVendCode'" @callback="getChargeName" ref="chargesingle"></selector>
    </div>
</template>

<script>
    import Common from '@/components/Common';
    import Array from '@/components/Array';
    import { Loading } from 'element-ui';
    export default {
        name:'3_purinvoiceview',
        computed: {
            tableOption() {
                return {
                    border: true,
                    height: this.$windowSize.tableHeight3- Common.reduceTableHeight3,
                    maxHeight: this.$windowSize.tableHeight3- Common.reduceTableHeight3,
                }
            },
            tableHeight(){
                return this.$windowSize.tableHeight3
            }
        },
        data() {
            return {
                tableHeader: [],
                dataSet: [], // 主表数据
                isVisible: false, // 查询列表是否显示
                queryData: [], // 查询数组
                userData: [], // 用户信息
                DbTbNames: '',
                pageIndex: 1, // 当前页
                pageSize: this.$http.getPageSize('PurInvoiceListViewInfo'), // 当前页数据量
                SelectIndexs: 1, //当前页面
                RightSelectIndex: '0',
                total: 0, // 数据总量
                loading: false, // 主表加载状态
                reduceTableHeight: Common.reduceTableHeight3,
                dataDetail: {
                    Head: {},
                    Lists: [],
                    OtherCostList: [],
                    ImgList:[]
                },
                diffAmount: '', // 合计本币差额
                netDiffAmount: '', // 合计原币差额
                oldDataDetail: '',
                dataDetailRed:{
                    Head: {},
                    Lists: [],
                    ImgList:[]
                },
                oldDataDetailRed: '',
                code: '', // 当前选择行代码（唯一）
                selectCodeData: [], //主表勾选invoice_no合集
                selectData:[],
                selectDataDetail:[],
                selectDataDetailRed: [],
                selectDataDetailCost:[],
                invoiceType: [],
                invoiceOrderType: [],
                balanceMode:[],
                IsPriceTax:0,//默认根据不含税价格计算含税价格、1根据含税价格计算不含税价格
                billmode: '1', // 选择器模式 ：整单模式 1 、行模式 2
                oneormore: 1,
                rowindex: -1,
                rowindexother: -1,//费用明细
                rowcache: null,
                oneormorered: 1,
                rowindexred: -1,
                dataDetailLineNo: 1, // 行号
                dataDetailLineNoCost: 1,
                dataDetailLineNoRed: 1,
                negativeflag: '0',// 0:普通单据1：红字单据
                negative_flag: 0,// 0:普通单据1：红字单据
                visAddType: false, // 新增类型弹窗控制
                auditCheckData: {
                    YearMonth:null,
                    Message:null,
                    DBYM:"",
                    SysYM:"",
                    Result:false
                },
                beforeEventName: '',// 校验审核期间后执行的方法名称
                visRate: false,
                visTaxRate: false,
                visChangeTaxRate: false,
                visChangeAuditDate: false,
                visUpdateUserStatus: false,
                auditCheckVisiable: false,
                userStatus: '',
                old_tax_rate: '',
                exchange_rate: '',
                tax_rate: '',
                audit_period: '',
                btn: {
                    batchaudit: false,
                    batchbalance: false,
                    batchrbalance: false,
                    cmuuser: false,
                    audit: false,
                    raudit: false,
                    balance: false,
                    rbalance: false,
                    setrate: false,
                    settaxrate: false,
                    settaxrateback: false,
                    editauditdate: false,
                    auditred: false,
                    rauditred: false,
                    balancered: false,
                    rbalancered: false,
                    setratered: false,
                    settaxratered: false,
                    settaxratebackred: false,
                    editauditdatered: false,
                    batchadd: false,
                    batchdel: false,
                    batchaddcost: false,
                    batchdelcost: false,
                    batchaddred: false,
                    batchdelred: false,
                    fkrq: false,
                    fkrqred: false
                },
                addoredit: 0, // 0:新增2：修改
                pickerOptionsInterval: {
                    disabledDate: this.disabledDate
                },
                visChangePayDate: false,
                payDate: '',
                fileList: [], //发票图片
                dialogImageUrl: '',
                dialogVisible: false,
                disabled: false,
                oldrow: '',
                iscontinuedblclick: true,
                timeId: null,
                //pdf文件显示
                src: '', // pdf文件地址
                showpdf: false,//发票图片是否显示pdf
                scrollTop:0,
                scrollTop1:0,
                scrollTop2:0,
                scrollTop3:0,

                priceDigit:this.$store.state.digitsetting.pur_price_digit,
                amountDigit:this.$store.state.digitsetting.pur_amount_digit,
            };
        },
        beforeRouteEnter(to, form, next) {
            next(vm => {
                if (form.name == 'logcarview' && Object.keys(vm.$store.state.sharedParams).length > 0) {
                    const data = {...vm.$store.state.sharedParams};
                    let date = Common.methods.getDate()
                    vm.billmode = '1'
                    vm.addoredit = 0
                    vm.dataDetail.Head = {
                        invoice_no: '',
                        invoice_code: '',
                        invoice_type_code: 'Increment_Invoice',
                        invoice_date: date,
                        order_type_code: 'StdPurchase',
                        balance_mode: '',
                        payment_period: '',
                        tax_code: '',
                        tax_rate: 0,
                        vender_name: data[0].Goods_Carrier,
                        vender_code: data[0].Vender_Code,
                        payment_date: '',
                        currency_code: '',
                        exchange_rate: 1,
                        create_person: '',
                        create_date: '',
                        audit_person: '',
                        audit_date: '',
                        net_total_amount: '',
                        vender_net_total_amount: '',
                        buyer: '',
                        invoice_status: '',
                        vender_remain_amount: '',
                        remain_amount: '',
                        remark: '',
                        total_amount: '',
                        tax_total_amount: '',
                        exchange_modify_person: '',
                        exchange_modify_date: '',
                        audit_period: '',
                        charge_invoice_flag: '',
                        virtual_flag: '',
                        negative_flag: '',
                        concurrent_time: '',
                        invoicenumlst: '',
                        invoice_usestatus: '',
                        payment_due_date: '',
                        bank_account_name: '',
                        bank_account_number: '',
                        tax_number: '',
                        isadd: 1
                    }
                    vm.dataDetail.Lists = []
                    vm.dataDetail.OtherCostList = []
                    let lineno = 1
                    for(let i = 0;i<data.length;i++){
                        vm.dataDetail.OtherCostList = [...vm.dataDetail.OtherCostList,{
                            relation_invoice_no: '',
                            line_no: lineno++,
                            charge_name: '',
                            net_unit_price: data[i].Actual_Cost,
                            unit_price: data[i].NoTaxed_Cost,
                            net_total_amount: '',
                            total_amount: '',
                            charge_qty: '',
                            base_net_unit_price: '',
                            base_unit_price: '',
                            base_net_total_amount: '',
                            base_total_amount: ''
                        }]
                    }
                    vm.dataDetail.ImgList=[]
                    vm.getSupplyFinanceInfo(data[0].Vender_Code)
                    setTimeout(() => {
                        vm.openEdit()
                    }, 500);
                    vm.$store.commit('clearSharedParams')
                }
                if (form.name == 'purbusiness' && Object.keys(vm.$store.state.sharedParams).length > 0) {
                    const data = {...vm.$store.state.sharedParams};
                    vm.getDetail(data.order_no, 1);
                    setTimeout(() => {
                        vm.openEdit()
                    }, 500);
                    vm.$store.commit('clearSharedParams')
                }
            });
        },
        watch:{
            dataSet: function(){
                let that = this
                that.$nextTick(function() {
                    that.$processdata.initForm(0)
                })
            },
            'dataDetail.Lists': function(){
                let that = this
                that.$nextTick(function() {
                    that.$processdata.initFormRight(this.RightSelectIndex)
                })
            },
            'dataDetail.OtherCostList': function(){
                let that = this
                that.$nextTick(function() {
                    that.$processdata.initFormRight(this.RightSelectIndex)
                })
            },
            'dataDetailRed.Lists': function(){
                let that = this
                that.$nextTick(function() {
                    that.$processdata.initFormRight(this.RightSelectIndex)
                })
            }
        },
        mounted: function() {
            let that = this;
            that.colsort();
            that.$processdata.pushModelCache('3_purinvoiceview', that)
            that.userData = sessionStorage.getItem('userData');
            that.invoiceType = Array.methods.getInvoiceType();
            that.invoiceOrderType = Array.methods.getInvoiceOrderType();
            that.balanceMode = Array.methods.getBalanceMode();
            that.IsPriceTax = Array.methods.getSysConfig("A95");
            console.log('参数:' + that.IsPriceTax)         
            that.$limits.dragControllerDiv();
            that.oldDataDetail = JSON.stringify(that.dataDetail)
            that.oldDataDetailRed = JSON.stringify(that.dataDetailRed)
            that.authority();
            that.confirmAdd()
        },
        activated () {
            let that = this
            setTimeout(() => {
                that.$refs.singleTable.$refs.singleTable.bodyWrapper.addEventListener('scroll', (res) => {
                    that.scrollTop = res.target.scrollTop
                },false)
                that.$refs.singleTable1.bodyWrapper.addEventListener('scroll', (res) => {
                    that.scrollTop1 = res.target.scrollTop
                },false)
                that.$refs.singleTable2.bodyWrapper.addEventListener('scroll', (res) => {
                    that.scrollTop2 = res.target.scrollTop
                },false)
                that.$refs.singleTable3.bodyWrapper.addEventListener('scroll', (res) => {
                    that.scrollTop3 = res.target.scrollTop
                },false)
            }, 5000);
            // 路由跳转回来滚动到离开时的位置
            this.$nextTick(()=> {
                setTimeout(() => {
                    this.$refs.singleTable.$refs.singleTable.bodyWrapper.scrollTop =this.scrollTop;
                    this.$refs.singleTable1.bodyWrapper.scrollTop =this.scrollTop1;
                    this.$refs.singleTable2.bodyWrapper.scrollTop =this.scrollTop2;
                    this.$refs.singleTable3.bodyWrapper.scrollTop =this.scrollTop3;
                }, 13)
            })
        },
        methods: {
            colsort() {
                let that = this;
                that.$loadviewfields.Fileds('PurInvoiceListViewInfo', 0, PFileds => {
                    that.tableHeader = PFileds;
                });
            },
            sortclick(val) {
                if (val == 1) {
                    this.colsort();
                }
            },
            // 修改表格顺序
            opentable() {
                this.$refs.ctab.clearInputs(true);
            },
            tableRowClassNameDetail({row, rowIndex}){
                row.index = rowIndex;
                if (row.vender_net_amount_diff != 0) {
                    return 'yellow';
                }
                if (row.tax_amount_diff != 0) {
                    return 'yellow2';
                }
            },
            tableRowClassNameDetailRed({row, rowIndex}){
                row.index = rowIndex;
            },
            tableRowClassNameDetailCost({row, rowIndex}){
                row.index = rowIndex;
            },
            leftt(e) {
                var left = document.getElementsByClassName('left');
                var mid = document.getElementsByClassName('mid');
                var Box = document.getElementsByClassName('Boxs');
                let bw = Box[0].clientWidth;
                if (e == 1) {
                    left[0].style.width = '0px';
                    mid[0].style.width = bw - 13 + 'px';
                } else {
                    left[0].style.width = bw - 50 + 'px';
                    mid[0].style.width = '0px';
                }
            },
            openEdit() {
                let that = this
                clearTimeout(that.timeId)
                if(!that.iscontinuedblclick){
                    return
                }
                let left = document.getElementsByClassName('left');
                let mid = document.getElementsByClassName('mid');
                let Box = document.getElementsByClassName('Boxs');
                let bw = Box[0].clientWidth;
                left[0].style.width = '0px';
                mid[0].style.width = '100%';
            },
            colseEdit(){
                let that = this
                let left = document.getElementsByClassName('left');
                let mid = document.getElementsByClassName('mid');
                let Box = document.getElementsByClassName('Boxs');
                let bw = Box[0].clientWidth;
                left[0].style.width = '100%';
                mid[0].style.width = '0px'
            },
            help(){
                this.$refs.SetBtn.showHelp(this.$options.name,this.$t("getapi[3676]"),this.$t("getapi[3836]"));
            },
            authority() {
                let that = this
                if(that.$loadviewfields.isEnableHelp(this.$options.name) == 1){
                    that.$refs.SetBtn.SetOneBtnEnable('help',true);
                }
                that.$refs.SetBtn.SetOneBtnEnable('ctabel', true);
                console.log('权限' + that.$limits.authority('plv2', 221, 1))
                if(!this.$limits.menuvisible("plv2", 221, 1)){
                    var value = that.$limits.newOperationAuthorityView('plv2', 220, 1, that.total);
                    console.log(that.$limits.authority('plv2', 220, 1))
                    console.log('权限' + value)
                    that.$refs.SetBtn.SetButtonEnable(value);
                } else {
                    if(that.negative_flag == 0){
                        if (that.$limits.authority('plv2', 221, 1) == 1) {
                            //只读权
                            that.$refs.SetBtn.SetButtonEnable('search,refresh');
                        }
                        if (that.$limits.authority('plv2', 221, 1) == 2) {
                            if (that.$limits.authority('plv2', 221, 1) == 1) {
                                //只读权
                                that.$refs.SetBtn.SetButtonEnable('search,refresh,export');
                            }
                            if (that.$limits.authority('plv2', 221, 1) == 2) {
                                if (that.$limits.authority('plv3', 221,1) == 0) {
                                    that.$refs.SetBtn.SetButtonEnable('search,refresh,export');
                                }
                                //操作权
                                if (that.$limits.authority('plv3', 221,1) == 1) {
                                    //编辑级
                                    that.$refs.SetBtn.SetButtonEnable('create,save,search,refresh,export');
                                }
                                if (that.$limits.authority('plv3', 221, 1) == 2) {
                                    //删除级
                                    if (!that.$limits.fnIsEmpty(that.dataDetail.Head.invoice_no) || !that.$limits.fnIsEmpty(that.dataDetailRed.Head.invoice_no)) {
                                        if(that.negative_flag == 0 && that.dataDetail.Head.invoice_status == 0){
                                            that.$refs.SetBtn.SetButtonEnable('create,save,del,search,refresh,export');
                                        } else {
                                            that.$refs.SetBtn.SetButtonEnable('create,save,search,refresh,export');
                                        }
                                    } else {
                                        that.$refs.SetBtn.SetButtonEnable('create,save,search,refresh,export');
                                    }
                                }
                            }
                        }
                    } else {
                        if (that.$limits.authority('plv2', 226, 1) == 1) {
                            //只读权
                            that.$refs.SetBtn.SetButtonEnable('search,refresh');
                        }
                        if (that.$limits.authority('plv2', 226, 1) == 2) {
                            if (that.$limits.authority('plv2', 226, 1) == 1) {
                                //只读权
                                that.$refs.SetBtn.SetButtonEnable('search,refresh,export');
                            }
                            if (that.$limits.authority('plv2', 226, 1) == 2) {
                                if (that.$limits.authority('plv3', 226,1) == 0) {
                                    that.$refs.SetBtn.SetButtonEnable('search,refresh,export');
                                }
                                //操作权
                                if (that.$limits.authority('plv3', 226,1) == 1) {
                                    //编辑级
                                    that.$refs.SetBtn.SetButtonEnable('create,save,search,refresh,export');
                                }
                                if (that.$limits.authority('plv3', 226, 1) == 2) {
                                    //删除级
                                    if (!that.$limits.fnIsEmpty(that.dataDetailRed.Head.invoice_no) || !that.$limits.fnIsEmpty(that.dataDetailRed.Head.invoice_no)) {
                                        if(that.negative_flag == 1 && that.dataDetailRed.Head.invoice_status == 0){
                                            that.$refs.SetBtn.SetButtonEnable('create,save,del,search,refresh,export');
                                        } else {
                                            that.$refs.SetBtn.SetButtonEnable('create,save,search,refresh,export');
                                        }
                                    } else {
                                        that.$refs.SetBtn.SetButtonEnable('create,save,search,refresh,export');
                                    }
                                }
                            }
                        }
                    }
                }
                that.btnauthority();
            },
            btnauthority() {
                let that = this;
                that.btn.batchaudit = false;
                //批量审核
                if(that.selectData.length > 0 ){
                    if(that.$limits.authority('plv4', 111, 1) > 0){
                        that.btn.batchaudit = that.selectData.every(val => {
                            return (val.negative_flag == '否' && val.invoice_status == '生成' && (that.$limits.authority('plv4', 166, 1) == 1? true: false)) ||
                                (val.negative_flag == '是' && val.invoice_status == '生成' && (that.$limits.authority('plv4', 180, 1) == 1? true: false))
                        });
                    }
                    console.log(that.btn.batchaudit)
                    /*that.btn.batchaudit = true;*/
                } else {
                    that.btn.batchaudit = false;
                }
                // 批量记账
                that.btn.batchbalance = false
                if(that.selectData.length > 0 ){
                    if(that.$limits.authority('plv4', 504, 1) > 0) {
                        that.btn.batchbalance = that.selectData.every(val => {
                            return val.invoice_status == '审核'
                        });
                    }
                    /*that.btn.batchbalance = true;*/
                } else {
                    that.btn.batchbalance = false;
                }
                // 批量反记账
                that.btn.batchrbalance = false
                if(that.selectData.length > 0 ){
                    if(that.$limits.authority('plv4', 505, 1) > 0) {
                        that.btn.batchrbalance = that.selectData.every(val => {
                            return val.invoice_status == '记账'
                        });
                    }
                    /*that.btn.batchrbalance = true;*/
                } else {
                    that.btn.batchrbalance = false;
                }
                that.btn.cmuuser = false;
                //更新发票使用状态
                if (that.$limits.authority('plv4', 109, 1) == 1) {
                    if(that.selectData.length == 1){
                        that.btn.cmuuser = true;
                    }
                }
                that.btn.audit = false
                that.btn.raudit = false
                that.btn.balance = false
                that.btn.rbalance = false
                that.btn.setrate = false
                that.btn.settaxrate = false
                that.btn.settaxrateback = false
                that.btn.editauditdate = false
                that.btn.batchadd = false
                that.btn.batchdel = false
                that.btn.batchaddcost = false
                that.btn.batchdelcost = false
                that.btn.fkrq = false
                if(that.dataDetail.Head.invoice_status == 0){ // 生成
                    that.btn.audit = that.$limits.authority('plv4', 166, 1) == 1? true: false
                    that.btn.setrate = that.$limits.authority('plv4', 269, 1) == 1? true: false
                    that.btn.settaxrate = that.$limits.authority('plv4', 269, 1) == 1? true: false
                    that.btn.settaxrateback = that.$limits.authority('plv4', 269, 1) == 1? true: false
                    that.btn.batchadd = true
                    that.btn.batchaddcost = true
                    if(that.selectDataDetail.length > 0 ){
                        that.btn.batchdel = true
                    }
                    if(that.selectDataDetailCost.length > 0){
                        that.btn.batchdelcost = true
                    }
                }
                if(that.dataDetail.Head.invoice_status == 1){ // 审核
                    that.btn.raudit = that.$limits.authority('plv4', 166, 1) == 1? true: false
                    that.btn.balance = that.$limits.authority('plv4', 168, 1) == 1? true: false
                    that.btn.editauditdate = that.$limits.authority('plv4', 334, 1) == 1? true: false
                }
                if(that.dataDetail.Head.invoice_status == 3){ // 记账
                    that.btn.rbalance = that.$limits.authority('plv4', 169, 1) == 1? true: false
                    that.btn.editauditdate = that.$limits.authority('plv4', 334, 1) == 1? true: false
                }
                if(that.dataDetail.Head.invoice_status == 4){
                    that.btn.editauditdate = false
                }
                that.btn.fkrq = that.btn.editauditdate

                that.btn.auditred = false
                that.btn.rauditred = false
                that.btn.balancered = false
                that.btn.rbalancered = false
                that.btn.setratered = false
                that.btn.settaxratered = false
                that.btn.settaxratebackred = false
                that.btn.editauditdatered = false
                that.btn.batchaddred = false
                that.btn.batchdelred = false
                that.btn.fkrqred = false
                if(that.dataDetailRed.Head.invoice_status == 0){
                    that.btn.auditred = that.$limits.authority('plv4', 180, 1) == 1? true: false
                    that.btn.setratered = that.$limits.authority('plv4', 270, 1) == 1? true: false
                    that.btn.settaxratered = that.$limits.authority('plv4', 270, 1) == 1? true: false
                    that.btn.settaxratebackred = that.$limits.authority('plv4', 270, 1) == 1? true: false
                    that.btn.batchaddred = true
                    if(that.selectDataDetailRed.length > 0 ){
                        that.btn.batchdelred = true
                    }
                }
                if(that.dataDetailRed.Head.invoice_status == 1){
                    that.btn.rauditred = that.$limits.authority('plv4', 181, 1) == 1? true: false
                    that.btn.balancered = that.$limits.authority('plv4', 182, 1) == 1? true: false
                    that.btn.editauditdatered = that.$limits.authority('plv4', 334, 1) == 1? true: false
                }
                if(that.dataDetailRed.Head.invoice_status == 3){
                    that.btn.rbalancered = that.$limits.authority('plv4', 183, 1) == 1? true: false
                    that.btn.editauditdatered = that.$limits.authority('plv4', 334, 1) == 1? true: false
                }
                if(that.dataDetailRed.Head.invoice_status == 4){
                    that.btn.editauditdate = false
                }
                that.btn.fkrqred = that.btn.editauditdatered
            },
            handleSizeChange(val) {
                this.pageSize = val;
                this.$http.savePageSize('PurInvoiceListViewInfo',val);
                this.getView();
            },
            handleCurrentChange(val) {
                this.pageIndex = val;
                this.getView();
            },
            // 查询
            search() {
                let that = this;
                that.isVisible = true;
                that.$refs.ser.clearInput(that.isVisible, 'PurInvoiceListViewInfo');
            },
            //获取查询条件
            serclick(val) {
                this.queryData = val;
                this.confirmGetView();
            },
            // 确认获取数据
            confirmGetView() {
                let that = this;
                that.pageIndex = 1
                that.isVisible = false;
                that.getView();
            },
            // 数据一览
            getView() {
                let that = this;
                that.loading = true;
                let datac = [];
                for (let i = 0; i < that.queryData.length; i++) {
                    datac.push({
                        query_Condition: that.queryData[i].query_Condition,
                        query_field_type: that.queryData[i].Query_Field_Type,
                        query_field_name: that.queryData[i].Query_Field_Name,
                        query_sort: that.queryData[i].query_sort,
                        row_sign: that.queryData[i].row_sign
                    });
                }
                let data = {
                    PageIndex: that.pageIndex,
                    PageSize: that.pageSize,
                    SelectIndex: that.SelectIndexs,
                    Param: datac
                };
                that.$http.urlpost('/Pur/Invoice/PurInvDataList', data, function(res) {
                    if (res.Success == 1) {
                        that.dataSet = res.DataContent;
                        that.total = res.Totals;
                        that.loading = false;
                        that.DbTbNames = res.DbTbNames;
                    } else {
                        that.$message.error(that.$processdata.explainCallbackMsg(res.Msg));
                    }
                });
            },
            // 刷新
            reflash() {
                /*let that = this;
                that.getView();
                if(that.addoredit == 0){
                    that.confirmAdd()
                } else {
                    if(that.negative_flag == 0){
                        that.getDetail(that.code)
                    } else {
                        that.getDetailRed(that.code)
                    }
                }*/
                let that = this
                if(that.negative_flag == 0){
                    let datacopy = that.dataDetail
                    for(let i = 0;i<datacopy.Lists.length;i++){
                        delete datacopy.Lists[i]['index']
                    }
                    for(let i = 0;i<datacopy.OtherCostList.length;i++){
                        delete datacopy.OtherCostList[i]['index']
                    }
                    if(that.oldDataDetail != JSON.stringify(datacopy)){
                        that.$confirm(that.$t('getapi[3659]'), that.$t('getapi[194]'), {//'数据已发生变更，是否保存后刷新？'
                            confirmButtonText: that.$t('getapi[2052]'),
                            cancelButtonText: that.$t('getapi[2053]'),
                            type: 'warning'
                        })
                            .then(() => {
                                that.save()
                            })
                            .catch(() => {
                                if(that.addoredit == 0){
                                    that.getView();
                                    that.confirmAdd()
                                } else {
                                    that.getView();
                                    that.getDetail(that.code)
                                }
                            });
                    } else {
                        if(that.addoredit == 0){
                            that.getView();
                            that.confirmAdd()
                        } else {
                            that.getView();
                            that.getDetail(that.code)
                        }
                    }
                } else {
                    let datacopyred = that.dataDetailRed
                    for(let i = 0;i<datacopyred.Lists.length;i++){
                        delete datacopyred.Lists[i]['index']
                    }
                    if(that.oldDataDetailRed != JSON.stringify(datacopyred)){
                        that.$confirm(that.$t('getapi[3659]'), that.$t('getapi[194]'), {//'数据已发生变更，是否保存后刷新？'
                            confirmButtonText: that.$t('getapi[2052]'),
                            cancelButtonText: that.$t('getapi[2053]'),
                            type: 'warning'
                        })
                            .then(() => {
                                that.save()
                            })
                            .catch(() => {
                                if(that.addoredit == 0){
                                    that.getView();
                                    that.confirmAdd()
                                } else {
                                    that.getView();
                                    that.getDetailRed(that.code)
                                }
                            });
                    } else {
                        if(that.addoredit == 0){
                            that.getView();
                            that.confirmAdd()
                        } else {
                            that.getView();
                            that.getDetailRed(that.code)
                        }
                    }
                }
            },
            // 导出
            exps() {
                let that = this;
                let datac = [];
                for (let i = 0; i < that.queryData.length; i++) {
                    datac.push({
                        query_Condition: that.queryData[i].query_Condition,
                        query_field_type: that.queryData[i].Query_Field_Type,
                        query_field_name: that.queryData[i].Query_Field_Name,
                        query_sort: that.queryData[i].query_sort,
                        row_sign: that.queryData[i].row_sign
                    });
                }
                let parm = {
                    PageIndex: that.PageIndex,
                    PageSize: that.PageSize,
                    SelectIndex: that.SelectIndex,
                    Ids: '',
                    Param: datac
                };
                that.$confirm(that.$t('getapi[8898]'), that.$t('getapi[194]'), {//'是导出图片吗？'
                    confirmButtonText: that.$t('getapi[2052]'),
                    cancelButtonText: that.$t('getapi[2053]'),
                    type: 'warning'
                })
                    .then(() => {
                        that.$refs.SetBtn.SetOneBtnEnable('exps',false);
                        that.$http.urlpost('/Pur/Invoice/PurInvExportToHtml', parm, function(res) {
                            that.$refs.SetBtn.SetOneBtnEnable('exps',true);
                            if (res.Success == 1) {
                                let hrefurl = Common.Url + res.DataContent.URL;
                                window.open(hrefurl);
                            }
                        });
                    })
                    .catch(() => {
                       /* that.$refs.SetBtn.SetOneBtnEnable('exps',false);
                        that.$http.urlpost('/Pur/Invoice/PurInvExportToExecl', parm, function(res) {
                            that.$refs.SetBtn.SetOneBtnEnable('exps',true);
                            if (res.Success == 1) {
                                let hrefurl = Common.Url + res.DataContent.URL;
                                window.open(hrefurl);
                            }
                        });*/
                        let param = {
                            query_sign: "PurInvoiceListViewInfo",
                            fromname: that.$t('getapi[3676]'),
                            SelectIndex: 0,
                            MultyVer: that.$processdata.getLanguage(),
                            Param: datac
                        };
                        that.$processdata.commonExport(param)
                    });
            },
            // 新增
            add(){
                let that = this
                if(that.negative_flag == 0){
                    let datacopy = that.dataDetail
                    for(let i = 0;i<datacopy.Lists.length;i++){
                        delete datacopy.Lists[i]['index']
                    }
                    for(let i = 0;i<datacopy.OtherCostList.length;i++){
                        delete datacopy.OtherCostList[i]['index']
                    }
                    if(that.oldDataDetail != JSON.stringify(datacopy)){
                        that.$confirm(that.$t('getapi[3657]'), that.$t('getapi[194]'), {//'数据已发生变更，是否保存后新建？'
                            confirmButtonText: that.$t('getapi[2052]'),
                            cancelButtonText: that.$t('getapi[2053]'),
                            type: 'warning'
                        })
                            .then(() => {
                                that.save()
                            })
                            .catch(() => {
                                that.openEdit()
                                that.visAddType = true
                            });
                    } else {
                        that.openEdit()
                        that.visAddType = true
                    }
                } else {
                    let datacopyred = that.dataDetailRed
                    for(let i = 0;i<datacopyred.Lists.length;i++){
                        delete datacopyred.Lists[i]['index']
                    }
                    if(that.oldDataDetailRed != JSON.stringify(datacopyred)){
                        that.$confirm(that.$t('getapi[3657]'), that.$t('getapi[194]'), {//'数据已发生变更，是否保存后新建？'
                            confirmButtonText: that.$t('getapi[2052]'),
                            cancelButtonText: that.$t('getapi[2053]'),
                            type: 'warning'
                        })
                            .then(() => {
                                that.save()
                            })
                            .catch(() => {
                                that.visAddType = true
                            });
                    } else {
                        that.visAddType = true
                    }
                }
            },
            confirmAdd(){
                let that = this
                let date = Common.methods.getDate()
                that.billmode = '1'
                that.addoredit = 0
                that.code = ''
                that.negative_flag = that.negativeflag
                that.visAddType = false
                that.diffAmount = '', // 合计本币差额
                that.netDiffAmount = '', // 合计原币差额
                that.dataDetail.Head = {
                    invoice_no: '',
                    invoice_code: '',
                    invoice_type_code: '',
                    invoice_date: date,
                    order_type_code: 'StdPurchase',
                    balance_mode: '',
                    payment_period: '',
                    tax_code: '',
                    tax_rate: 0,
                    vender_name: '',
                    vender_code: '',
                    payment_date: '',
                    currency_code: '',
                    exchange_rate: 1,
                    create_person: '',
                    create_date: '',
                    audit_person: '',
                    audit_date: '',
                    net_total_amount: '',
                    vender_net_total_amount: '',
                    buyer: '',
                    invoice_status: '',
                    vender_remain_amount: '',
                    remain_amount: '',
                    remark: '',
                    total_amount: '',
                    tax_total_amount: '',
                    exchange_modify_person: '',
                    exchange_modify_date: '',
                    audit_period: '',
                    charge_invoice_flag: '',
                    virtual_flag: '',
                    negative_flag: '',
                    concurrent_time: '',
                    invoicenumlst: '',
                    invoice_usestatus: '',
                    payment_due_date: '',
                    bank_account_name: '',
                    bank_account_number: '',
                    tax_number: '',
                    isadd: 1
                }
                that.dataDetail.Lists = []
                that.dataDetail.OtherCostList = []
                that.dataDetail.ImgList=[]
                that.oldDataDetail = JSON.stringify(that.dataDetail)
                that.dataDetailRed.Head = {
                    invoice_no:'',
                    invoice_code:'',
                    invoice_type_code:'',
                    invoice_date:date,
                    order_type_code:'StdPurchase',
                    balance_mode:'',
                    payment_period:'',
                    tax_code:'',
                    tax_rate:0,
                    vender_name:'',
                    vender_code:'',
                    payment_date:'',
                    currency_code:'',
                    exchange_rate:1,
                    create_person:'',
                    create_date:'',
                    audit_person:'',
                    audit_date:'',
                    net_total_amount:'',
                    vender_net_total_amount:'',
                    buyer:null,
                    invoice_status:'',
                    vender_remain_amount:0.0,
                    remain_amount:0.0,
                    remark:null,
                    total_amount:'',
                    tax_total_amount:'',
                    exchange_modify_person:null,
                    exchange_modify_date:null,
                    audit_period:'',
                    charge_invoice_flag:0,
                    virtual_flag:0,
                    negative_flag:'1',
                    concurrent_time:'',
                    invoicenumlst:'',
                    invoice_usestatus:null,
                    payment_due_date:null,
                    bank_account_name:"",
                    bank_account_number:"",
                    tax_number:"",
                    isadd:1
                }
                that.dataDetailRed.Lists = []
                that.dataDetailRed.ImgList=[]
                that.oldDataDetailRed = JSON.stringify(that.dataDetailRed)
                that.authority()
            },
            save(){
                let that = this
                if(that.negative_flag == 0){
                    let parm = {
                        Head: that.dataDetail.Head,
                        Lists: that.dataDetail.Lists,
                        OtherCostList: that.dataDetail.OtherCostList,
                        LangType: that.$processdata.getLang(),
                    }
                    that.$refs.SetBtn.SetOneBtnEnable('save', false);
                    that.$http.urlpost('/Pur/Invoice/SaveData', parm, function(res) {
                        if (res.Success == 1) {
                            that.$message.success(that.$processdata.explainCallbackMsg(res.Msg))
                            that.code = res.UniqueNum
                            that.getDetail(res.UniqueNum)
                        }
                        that.$refs.SetBtn.SetOneBtnEnable('save', true);
                    });
                } else {
                    let parm = {
                        Head: that.dataDetailRed.Head,
                        Lists: that.dataDetailRed.Lists,
                        LangType: that.$processdata.getLang(),
                    }
                    that.$refs.SetBtn.SetOneBtnEnable('save', false);
                    that.$http.urlpost('/Pur/Invoice/RedSaveData', parm, function(res) {
                        if (res.Success == 1) {
                            that.$message.success(that.$processdata.explainCallbackMsg(res.Msg))
                            that.code = res.UniqueNum
                            that.getDetailRed(res.UniqueNum)
                        }
                        that.$refs.SetBtn.SetOneBtnEnable('save', true);
                    });
                }
            },
            del(){
                let that = this
                this.$confirm(that.$t('getapi[4532]'), that.$t('getapi[194]'), {//'确定删除数据?'
                    confirmButtonText: that.$t('getapi[1146]'),
                    cancelButtonText: that.$t('getapi[2054]'),
                    type: 'warning'
                })
				.then(() => { 
                    if(that.negative_flag == 0){
                        let parm = {
                            invoice_no: that.dataDetail.Head.invoice_no,
                            concurrent_time: that.dataDetail.Head.concurrent_time,
                            LangType: that.$processdata.getLang(),
                        }
                        that.$http.urlpost('/Pur/Invoice/DelPurInvoice', parm, function(res) {
                            if (res.Success == 1) {
                                that.$message.success(that.$processdata.explainCallbackMsg(res.Msg))
                                that.getView()
                                that.confirmAdd()
                            }
                        });
                    } else {
                        let parm = {
                            invoice_no: that.dataDetailRed.Head.invoice_no,
                            concurrent_time: that.dataDetailRed.Head.concurrent_time,
                            virtual_flag: that.dataDetailRed.Head.virtual_flag,
                            Lists: [],
                            LangType: that.$processdata.getLang(),
                        }
                        for(let i = 0;i<that.dataDetailRed.Lists.length;i++){
                            parm.Lists = [...parm.Lists,{
                                receive_order_no: that.dataDetailRed.Lists[i].receive_order_no
                            }]
                        }
                        that.$http.urlpost('/Pur/Invoice/DelRedPurInvoice', parm, function(res) {
                            if (res.Success == 1) {
                                that.$message.success(that.$processdata.explainCallbackMsg(res.Msg))
                                that.getView()
                                that.confirmAdd()
                            }
                        });
                    }
                })
				.catch(() => {
					this.$message({
						type: 'info',
						message: that.$t('getapi[8574]')
					});
				});  
            },
            editInfo(row){
                let that = this
                if(that.code == row.invoice_no){
                    return
                }
                that.timeId = setTimeout(() => {
                    if(!this.$limits.menuvisible("plv2", 221, 1)){
                        return
                    }
                    if(row.negative_flag == '否'){
                        let datacopy = that.dataDetail
                        for(let i = 0;i<datacopy.Lists.length;i++){
                            delete datacopy.Lists[i]['index']
                        }
                        for(let i = 0;i<datacopy.OtherCostList.length;i++){
                            delete datacopy.OtherCostList[i]['index']
                        }
                        if(that.oldDataDetail != JSON.stringify(datacopy)){
                            that.$confirm(that.$t('getapi[8577]'), that.$t('getapi[194]'), {//'数据已发生变更还未保存，是否切换？'
                                confirmButtonText: that.$t('getapi[2052]'),
                                cancelButtonText: that.$t('getapi[2053]'),
                                closeOnClickModal: false,
                                type: 'warning'
                            })
                                .then(() => {
                                    that.iscontinuedblclick = true
                                    that.oldrow = row
                                    that.code = row.invoice_no
                                    that.getDetail(row.invoice_no)
                                    that.negative_flag = 0
                                })
                                .catch(() => {
                                    that.iscontinuedblclick = false
                                    that.$refs.singleTable.$refs.singleTable.setCurrentRow(that.oldrow)
                                });
                        } else {
                            that.iscontinuedblclick = true
                            that.oldrow = row
                            that.code = row.invoice_no
                            that.getDetail(row.invoice_no)
                            that.negative_flag = 0
                        }
                    } else if(row.negative_flag == '是'){
                        let datacopyred = that.dataDetailRed
                        for(let i = 0;i<datacopyred.Lists.length;i++){
                            delete datacopyred.Lists[i]['index']
                        }
                        if(that.oldDataDetailRed != JSON.stringify(datacopyred)){
                            that.$confirm(that.$t('getapi[8577]'), that.$t('getapi[194]'), {//'数据已发生变更还未保存，是否切换？'
                                confirmButtonText: that.$t('getapi[2052]'),
                                cancelButtonText: that.$t('getapi[2053]'),
                                type: 'warning'
                            })
                                .then(() => {
                                    that.oldrow = row
                                    that.code = row.invoice_no
                                    that.getDetailRed(row.invoice_no)
                                    that.negative_flag = 1
                                })
                                .catch(() => {
                                    that.$refs.singleTable.$refs.singleTable.setCurrentRow(that.oldrow)
                                });
                        } else {
                            that.oldrow = row
                            that.code = row.invoice_no
                            that.getDetailRed(row.invoice_no)
                            that.negative_flag = 1
                        }
                    }
                }, 100);
            },
            // 获取详情数据
            getDetail(code) {
                let that = this;
                that.addoredit = 1
                let parm = {
                    Code: code
                };
                let loadingInstance = Loading.service(Common.maskoption);
                that.$http.urlpost('/Pur/Invoice/GetPurInvoiceBillInfo', parm, function (res) {
                    if (res.Success == 1) {
                        that.dataDetail = res.DataContent;
                        that.dataDetail.Head.isadd = 0
                        that.dataDetail.Head.negative_flag = that.dataDetail.Head.negative_flag.toString()
                        that.dataDetail.Head.virtual_flag = that.dataDetail.Head.virtual_flag.toString()
                        that.dataDetail.Head.charge_invoice_flag = that.dataDetail.Head.charge_invoice_flag.toString()
                        if(that.dataDetail.ImgList.length == 1){
                            let str = that.dataDetail.ImgList[0].HttpFilePath
                            if(str.slice(str.length - 3,str.length).toLowerCase()=='pdf'){
                                that.src = str
                                that.showpdf = true
                            } else {
                                that.showpdf = false
                                that.fileList = []
                                that.fileList = [...that.fileList,{
                                    invoice_no: that.dataDetail.ImgList[0].invoice_no,
                                    wxserviceid: that.dataDetail.ImgList[0].wxserviceid,
                                    name: '',
                                    url: that.dataDetail.ImgList[0].HttpFilePath
                                }]
                            }
                        } else if(that.dataDetail.ImgList.length > 1){
                            that.showpdf = false
                            that.fileList = []
                            for(let i = 0 ;i<that.dataDetail.ImgList.length;i++){
                                that.fileList = [...that.fileList,{
                                    invoice_no: that.dataDetail.ImgList[i].invoice_no,
                                    wxserviceid: that.dataDetail.ImgList[i].wxserviceid,
                                    name: '',
                                    url: that.dataDetail.ImgList[i].HttpFilePath
                                }]
                            }
                        } else {
                            that.showpdf = false
                            that.fileList = []
                        }
                        that.diffAmount = 0
                        that.netDiffAmount = 0
                        for(let i = 0;i<that.dataDetail.Lists.length;i++){
                            that.diffAmount += that.$processdata.mathRound2(that.dataDetail.Lists[i].diff_amount)
                            that.diffAmount = that.$processdata.mathRound2(that.diffAmount)
                            that.netDiffAmount += that.$processdata.mathRound2(that.dataDetail.Lists[i].vender_net_amount_diff)
                            that.netDiffAmount = that.$processdata.mathRound2(that.netDiffAmount)
                        }
                        that.oldDataDetail = JSON.stringify(that.dataDetail)

                        that.authority();
                        that.btnauthority()
                    }
                    loadingInstance.close()
                });
            },
            // 获取详情数据-红单
            getDetailRed(code){
                let that = this;
                that.addoredit = 1
                let parm = {
                    Code: code
                };
                let loadingInstance = Loading.service(Common.maskoption);
                that.$http.urlpost('/Pur/Invoice/GetRedPurInvoiceBillInfo', parm, function (res) {
                    if (res.Success == 1) {
                        that.dataDetailRed = res.DataContent;
                        that.dataDetailRed.Head.isadd = 0
                        that.dataDetailRed.Head.negative_flag = that.dataDetailRed.Head.negative_flag.toString()
                        that.dataDetailRed.Head.virtual_flag = that.dataDetailRed.Head.virtual_flag.toString()
                        if(that.dataDetailRed.ImgList.length == 1){
                            let str = that.dataDetailRed.ImgList[0].HttpFilePath
                            if(str.slice(str.length - 3,str.length).toLowerCase()=='pdf'){
                                that.src = str
                                that.showpdf = true
                            } else {
                                that.showpdf = false
                                that.fileList = []
                                that.fileList = [...that.fileList,{
                                    invoice_no: that.dataDetailRed.ImgList[0].invoice_no,
                                    wxserviceid: that.dataDetailRed.ImgList[0].wxserviceid,
                                    name: '',
                                    url: that.dataDetailRed.ImgList[0].HttpFilePath
                                }]
                            }
                        }else if(that.dataDetailRed.ImgList.length > 1){
                            that.fileList = []
                            for(let i = 0 ;i<that.dataDetailRed.ImgList.length;i++){
                                that.fileList = [...that.fileList,{
                                    invoice_no: that.dataDetailRed.ImgList[i].invoice_no,
                                    wxserviceid: that.dataDetailRed.ImgList[i].wxserviceid,
                                    name: '',
                                    url: that.dataDetailRed.ImgList[i].HttpFilePath
                                }]
                            }
                        } else {
                            that.fileList = []
                        }
                        that.oldDataDetailRed = JSON.stringify(that.dataDetailRed)
                        that.authority();
                        that.btnauthority()
                    }
                    loadingInstance.close()
                });
            },
            handleSelectionChange(val){
                let that = this
                that.selectCodeData = []
                that.selectData = []
                for(let i = 0;i<val.length;i++){
                    that.selectCodeData.push(val[i].invoice_no)
                    that.selectData.push(val[i])
                }
                that.btnauthority();
            },
            // 勾选发票明细
            handleSelectionChangeDetail(val){
                let that = this
                that.selectDataDetail = []
                for(let i = 0;i<val.length;i++){
                    that.selectDataDetail.push(val[i])
                }
                that.btnauthority()
            },
            // 勾选发票明细 - 红字
            handleSelectionChangeDetailRed(val){
                let that = this
                that.selectDataDetailRed = []
                for(let i = 0;i<val.length;i++){
                    that.selectDataDetailRed.push(val[i])
                }
                that.btnauthority()
            },
            // 勾选费用明细
            handleSelectionChangeDetailCost(val){
                let that = this
                that.selectDataDetailCost = []
                for(let i = 0;i<val.length;i++){
                    that.selectDataDetailCost.push(val[i])
                }
                that.btnauthority()
            },
            //批量记账
            batchBalance(){
                let that = this
                if(that.selectCodeData.length == 0){
                    that.$message.warning(that.$t('getapi[1158]'))//请选择数据！
                    return
                }
                let ids = ''
                for(let i = 0;i<that.selectCodeData.length;i++){
                    ids = ids + that.selectCodeData[i] + ','
                }
                let parm = {
                    ids: ids
                }
                that.$http.urlpost('/Pur/Invoice/PurInvBatchBalance', parm, function (res) {
                    if (res.Success == 1) {
                        that.$message.success(that.$processdata.explainCallbackMsg(res.Msg))
                        that.getView()
                    }
                });
            },
            //批量反记账
            batchNoBalance(){
                let that = this
                if(that.selectCodeData.length == 0){
                    that.$message.warning(that.$t('getapi[1158]'))//请选择数据！
                    return
                }
                let ids = ''
                for(let i = 0;i<that.selectCodeData.length;i++){
                    ids = ids + that.selectCodeData[i] + ','
                }
                let parm = {
                    ids: ids
                }
                that.$http.urlpost('/Pur/Invoice/PurInvBatchNoBalance', parm, function (res) {
                    if (res.Success == 1) {
                        that.$message.success(that.$processdata.explainCallbackMsg(res.Msg))
                        that.getView()
                    }
                });
            },
            beforeUpdateUserStatus(){
                let that = this
                that.userStatus = that.selectData[0].invoice_usestatus
                that.visUpdateUserStatus = true
            },
            // 更行发票使用状态
            updateUserStatus(){
                let that = this
                console.log(that.selectData)
                let parm = {
                    invoice_no: that.selectData[0].invoice_no,
                    UseStatus: that.userStatus
                }
                that.$http.urlpost('/Pur/Invoice/PurInvoiceUpdateUserStatus', parm, function (res) {
                    if (res.Success == 1) {
                        that.$message.success(that.$processdata.explainCallbackMsg(res.Msg))
                        that.visUpdateUserStatus = false
                        that.getView()
                    }
                });
            },
            beforeBatchAudit(){
              let that = this
                that.beforeEventName = 'batchAudit'
                that.checkAuditTime()
            },
            // 批量审核
            batchAudit(){
                let that = this
                if(that.selectCodeData.length == 0){
                    that.$message.warning(that.$t('getapi[1158]'))//请选择数据！
                    return
                }
                let ids = ''
                for(let i = 0;i<that.selectCodeData.length;i++){
                    ids = ids + that.selectCodeData[i] + ','
                }
                let parm = {
                    ids: ids,
                    YearMonth: that.auditCheckData.YearMonth,
                    LangType: that.$processdata.getLang(),
                }
                that.$http.urlpost('/Pur/Invoice/PurInvBatchAudit', parm, function (res) {
                    if (res.Success == 1) {
                        that.$message.success(that.$processdata.explainCallbackMsg(res.Msg))
                        that.getView()
                    }
                });
            },
            expInvoiceStatus(val){
                let that = this
                if(val == 0){
                    return that.$t('getapi[1422]')//'生成'
                } else if(val == 1){
                    return that.$t('getapi[941]')//'审核'
                } else if(val == 2){
                    return that.$t('getapi[8921]')//'钩稽'
                } else if(val == 3){
                    return that.$t('getapi[1868]')//'记账'
                } else if(val == 4){
                    return that.$t('getapi[3754]')//'月结'
                } else if(val == 5){
                    return that.$t('getapi[3755]')//'作废'
                } else {
                    return ''
                }
            },
            // 新增单据
            showAddOrder(row) {
                let that = this;
                if(that.dataDetail.Head.vender_code == '' || that.dataDetail.Head.vender_code == null){
                    that.$message.warning(that.$t('getapi[8896]'));//'供应商不能为空'
                    return
                }
                if (row == '') {
                    that.oneormore = 1;
                    let  param =  {
                        billmode: that.billmode,
                        vendcode: that.dataDetail.Head.vender_code
                    }
                    that.$refs.order.clearInput(true, param);
                } else {
                    that.oneormore = 2;
                    that.rowindex = row.$index;
                    let  param =  {
                        billmode: that.billmode,
                        vendcode: that.dataDetail.Head.vender_code
                    }
                    that.$refs.ordersingle.clearInput(true, param);
                }
            },
            // 新增明细 - 红字
            showAddOrderRed(row) {
                let that = this;
                if(that.dataDetailRed.Head.vender_code == '' || that.dataDetailRed.Head.vender_code == null){
                    that.$message.warning(that.$t('getapi[8896]'));//'供应商不能为空'
                    return
                }
                if (row == '') {
                    that.oneormorered = 1;
                    let  param =  {
                        billmode: that.billmode,
                        vendcode: that.dataDetailRed.Head.vender_code
                    }
                    that.$refs.orderred.clearInput(true, param);
                } else {
                    that.oneormorered = 2;
                    that.rowindexred = row.$index;
                    let  param =  {
                        billmode: that.billmode,
                        vendcode: that.dataDetailRed.Head.vender_code
                    }
                    that.$refs.ordersinglered.clearInput(true, param);
                }
            },
            getorder(data){
                let that = this
                console.log(data)
                if(that.billmode == 1){
                    let orderArr = []
                    if(data.length > 0){
                        for(let i = 0;i<data.length;i++){
                            orderArr = [...orderArr, {order_no: data[i].order_no}]
                        }
                    } else {
                        orderArr.push(data)
                    }
                    let parm = {
                        vender_code: that.dataDetail.Head.vender_code,
                        IsWai: that.dataDetail.Head.currency_code == 'CNY'? 0:1,
                        Lists: orderArr
                    }
                    let loadingInstance = Loading.service(Common.maskoption1);
                    that.$http.urlpost('/Pur/Invoice/GetPurReceiveInListByOrderNo', parm, function (res) {
                        if (res.Success == 1) {
                            let resData = res.DataContent.Lists
                            that.dataDetailLineNo = 1
                            if(that.oneormore == 1) {
                                for (let i = 0; i < that.dataDetail.Lists.length; i++) {
                                    if (that.dataDetail.Lists[i].line_no >= that.dataDetailLineNo) {
                                        that.dataDetailLineNo = parseInt(that.dataDetail.Lists[i].line_no) + 1
                                    }
                                }
                                for(let i = 0; i < resData.length;i++){
                                    that.dataDetail.Lists = [...that.dataDetail.Lists, {
                                        relation_invoice_no: resData[i].relation_invoice_no,
                                        line_no:that.dataDetailLineNo++,
                                        receive_order_no:resData[i].receive_order_no,
                                        receive_order_line_no:resData[i].receive_order_line_no,
                                        part_code:resData[i].part_code,
                                        part_version:resData[i].part_version,
                                        part_name:resData[i].part_name,
                                        part_model:resData[i].part_model,
                                        part_spec:resData[i].part_spec,
                                        part_stuff:resData[i].part_stuff,
                                        measure_unit:resData[i].measure_unit,
                                        invoice_qty:resData[i].invoice_qty,
                                        net_unit_price:resData[i].net_unit_price.toFixed(that.priceDigit),
                                        unit_price:resData[i].unit_price.toFixed(that.priceDigit),
                                        line_net_total_amount:resData[i].line_net_total_amount.toFixed(that.amountDigit),
                                        tax_amount:resData[i].tax_amount.toFixed(that.amountDigit),
                                        line_total_amount:resData[i].line_total_amount.toFixed(that.amountDigit),
                                        vender_net_unit_price:resData[i].vender_net_unit_price.toFixed(that.priceDigit),
                                        vender_unit_price:resData[i].vender_unit_price.toFixed(that.priceDigit),
                                        vender_line_net_total_amount:resData[i].vender_line_net_total_amount.toFixed(that.amountDigit),
                                        vender_net_amount_diff:resData[i].vender_net_amount_diff.toFixed(that.amountDigit),
                                        line_remark:resData[i].line_remark,
                                        po_code:resData[i].po_code,
                                        po_line_id:resData[i].po_line_id,
                                        category_first:resData[i].category_first,
                                        category_second:resData[i].category_second,
                                        category_third:resData[i].category_third,
                                        negative_flag:resData[i].negative_flag,
                                        already_invoice_qty:resData[i].already_invoice_qty,
                                        receive_line_total_amount:resData[i].receive_line_total_amount.toFixed(that.amountDigit),
                                        diff_amount:resData[i].diff_amount.toFixed(that.amountDigit),
                                        order_line_total_amount:resData[i].order_line_total_amount.toFixed(that.amountDigit),
                                        tax_amount_diff:resData[i].tax_amount_diff.toFixed(that.amountDigit)
                                    }]
                                }
                            } else {
                                that.dataDetail.Lists[that.rowindex].relation_invoice_no='',
                                    that.dataDetail.Lists[that.rowindex].receive_order_no=resData[0].receive_order_no,
                                    that.dataDetail.Lists[that.rowindex].receive_order_line_no=resData[0].receive_order_line_no,
                                    that.dataDetail.Lists[that.rowindex].part_code=resData[0].part_code,
                                    that.dataDetail.Lists[that.rowindex].part_version=resData[0].part_version,
                                    that.dataDetail.Lists[that.rowindex].part_name=resData[0].part_name,
                                    that.dataDetail.Lists[that.rowindex].part_model=resData[0].part_model,
                                    that.dataDetail.Lists[that.rowindex].part_spec=resData[0].part_spec,
                                    that.dataDetail.Lists[that.rowindex].part_stuff=resData[0].part_stuff,                                    
                                    that.dataDetail.Lists[that.rowindex].measure_unit=resData[0].measure_unit,
                                    that.dataDetail.Lists[that.rowindex].invoice_qty=resData[0].invoice_qty,
                                    that.dataDetail.Lists[that.rowindex].net_unit_price=resData[0].net_unit_price.toFixed(that.priceDigit),
                                    that.dataDetail.Lists[that.rowindex].unit_price=resData[0].unit_price.toFixed(that.priceDigit),
                                    that.dataDetail.Lists[that.rowindex].line_net_total_amount=resData[0].line_net_total_amount.toFixed(that.amountDigit),
                                    that.dataDetail.Lists[that.rowindex].tax_amount=resData[0].tax_amount.toFixed(that.amountDigit),
                                    that.dataDetail.Lists[that.rowindex].line_total_amount=resData[0].line_total_amount.toFixed(that.amountDigit),
                                    that.dataDetail.Lists[that.rowindex].vender_net_unit_price=resData[0].vender_net_unit_price.toFixed(that.priceDigit),
                                    that.dataDetail.Lists[that.rowindex].vender_unit_price=resData[0].vender_unit_price.toFixed(that.priceDigit),
                                    that.dataDetail.Lists[that.rowindex].vender_line_net_total_amount=resData[0].vender_line_net_total_amount.toFixed(that.amountDigit),
                                    that.dataDetail.Lists[that.rowindex].vender_net_amount_diff=resData[0].vender_net_amount_diff.toFixed(that.amountDigit),
                                    that.dataDetail.Lists[that.rowindex].line_remark=resData[0].line_remark,
                                    that.dataDetail.Lists[that.rowindex].po_code=resData[0].po_code,
                                    that.dataDetail.Lists[that.rowindex].po_line_id=resData[0].po_line_id,
                                    that.dataDetail.Lists[that.rowindex].category_first=resData[0].category_first,
                                    that.dataDetail.Lists[that.rowindex].category_second=resData[0].category_second,
                                    that.dataDetail.Lists[that.rowindex].category_third=resData[0].category_third,
                                    that.dataDetail.Lists[that.rowindex].negative_flag=resData[0].negative_flag,
                                    that.dataDetail.Lists[that.rowindex].already_invoice_qty=resData[0].already_invoice_qty,
                                    that.dataDetail.Lists[that.rowindex].receive_line_total_amount=resData[0].receive_line_total_amount.toFixed(that.amountDigit),
                                    that.dataDetail.Lists[that.rowindex].diff_amount=resData[0].diff_amount.toFixed(that.amountDigit),
                                    that.dataDetail.Lists[that.rowindex].order_line_total_amount=resData[0].order_line_total_amount.toFixed(that.amountDigit),
                                    that.dataDetail.Lists[that.rowindex].tax_amount_diff=resData[0].tax_amount_diff.toFixed(that.amountDigit)
                            }
                        }
                        loadingInstance.close()
                    });
                } else {
                    if(that.oneormore == 1) {
                        console.log(data)
                        let newindex = that.dataDetail.Lists.length
                        that.dataDetailLineNo = 1
                        for (let i = 0; i < that.dataDetail.Lists.length; i++) {
                            if (that.dataDetail.Lists[i].line_no >= that.dataDetailLineNo) {
                                that.dataDetailLineNo = parseInt(that.dataDetail.Lists[i].line_no) + 1
                            }
                        }
                        for(let i = 0; i < data.length;i++){
                            that.dataDetail.Lists = [...that.dataDetail.Lists, {
                                relation_invoice_no: '',
                                line_no:that.dataDetailLineNo++,
                                receive_order_no:data[i].relation_order_no,
                                receive_order_line_no:data[i].line_no,
                                part_code:data[i].part_code,
                                part_version:data[i].part_version,
                                part_name:data[i].part_name,
                                part_model:data[i].part_model,
                                part_spec:data[i].part_spec,
                                part_stuff:data[i].part_stuff,
                                measure_unit:data[i].pur_measure,
                                invoice_qty:data[i].pur_measure_actually_qty,
                                net_unit_price:'',
                                unit_price:'',
                                line_net_total_amount:'',
                                tax_amount:'',
                                line_total_amount:'',
                                vender_net_unit_price:data[i].line_net_unitprice.toFixed(that.priceDigit),
                                vender_unit_price:data[i].line_total_unitprice.toFixed(that.priceDigit),
                                vender_line_net_total_amount:'',
                                vender_net_amount_diff:data[i].vender_net_amount_diff,
                                line_remark:'',
                                po_code:data[i].po_code,
                                po_line_id:data[i].po_line_id,
                                category_first:data[i].category_first,
                                category_second:data[i].category_second,
                                category_third:data[i].category_third,
                                negative_flag:data[i].negative_flag==false?0:1,
                                already_invoice_qty:data[i].releaseinvoiceqty,
                                receive_line_total_amount:data[i].receive_line_total_amount.toFixed(that.amountDigit),
                                diff_amount:'',
                                order_line_total_amount:data[i].order_line_total_amount.toFixed(that.amountDigit),
                                tax_amount_diff: 0
                            }]
                            for(let i = newindex;i<that.dataDetail.Lists.length;i++){
                                that.dataDetail.Lists[i].net_unit_price = (that.dataDetail.Lists[i].vender_net_unit_price* parseFloat(that.dataDetail.Head.exchange_rate)).toFixed(that.priceDigit)
                                that.dataDetail.Lists[i].unit_price = (that.dataDetail.Lists[i].vender_unit_price * parseFloat(that.dataDetail.Head.exchange_rate)).toFixed(that.priceDigit)
                                that.dataDetail.Lists[i].vender_line_net_total_amount = (parseFloat(that.dataDetail.Lists[i].vender_net_unit_price) * parseFloat(that.dataDetail.Lists[i].invoice_qty)).toFixed(that.amountDigit)
                                that.dataDetail.Lists[i].line_net_total_amount = (that.dataDetail.Lists[i].vender_line_net_total_amount * parseFloat(that.dataDetail.Head.exchange_rate)).toFixed(that.amountDigit)
                                that.dataDetail.Lists[i].tax_amount = (that.dataDetail.Lists[i].line_net_total_amount * that.dataDetail.Head.tax_rate / 100 ).toFixed(that.amountDigit)
                                that.dataDetail.Lists[i].line_total_amount = ((parseFloat(that.dataDetail.Lists[i].line_net_total_amount) + parseFloat(that.dataDetail.Lists[i].tax_amount))).toFixed(that.amountDigit)
                                that.dataDetail.Lists[i].diff_amount=(parseFloat(that.dataDetail.Lists[i].line_net_total_amount)) - (parseFloat(that.dataDetail.Lists[i].receive_line_total_amount)).toFixed(that.amountDigit)
                            }
                        }
                    } else {
                        that.dataDetail.Lists[that.rowindex].relation_invoice_no= '',
                        that.dataDetail.Lists[that.rowindex].receive_order_no=data.relation_order_no,
                        that.dataDetail.Lists[that.rowindex].receive_order_line_no=data.line_no,
                        that.dataDetail.Lists[that.rowindex].part_code=data.part_code,
                        that.dataDetail.Lists[that.rowindex].part_version=data.part_version,
                        that.dataDetail.Lists[that.rowindex].part_name=data.part_name,
                        that.dataDetail.Lists[that.rowindex].part_model=data.part_model,
                        that.dataDetail.Lists[that.rowindex].part_spec=data.part_spec,
                        that.dataDetail.Lists[that.rowindex].part_stuff=data.part_stuff,                        
                        that.dataDetail.Lists[that.rowindex].measure_unit=data.pur_measure,
                        that.dataDetail.Lists[that.rowindex].invoice_qty=data.pur_measure_actually_qty,
                        that.dataDetail.Lists[that.rowindex].net_unit_price='',
                        that.dataDetail.Lists[that.rowindex].unit_price='',                        
                        that.dataDetail.Lists[that.rowindex].line_net_total_amount='',
                        that.dataDetail.Lists[that.rowindex].tax_amount='',
                        that.dataDetail.Lists[that.rowindex].line_total_amount='',
                        that.dataDetail.Lists[that.rowindex].vender_net_unit_price=data.line_net_unitprice,
                        that.dataDetail.Lists[that.rowindex].vender_unit_price=data.line_total_unitprice,
                        that.dataDetail.Lists[that.rowindex].vender_line_net_total_amount='',
                        that.dataDetail.Lists[that.rowindex].vender_net_amount_diff='',
                        that.dataDetail.Lists[that.rowindex].line_remark='',
                        that.dataDetail.Lists[that.rowindex].po_code=data.po_code,
                        that.dataDetail.Lists[that.rowindex].po_line_id=data.po_line_id,
                        that.dataDetail.Lists[that.rowindex].category_first=data.category_first,
                        that.dataDetail.Lists[that.rowindex].category_second=data.category_second,
                        that.dataDetail.Lists[that.rowindex].category_third=data.category_third,
                        that.dataDetail.Lists[that.rowindex].negative_flag='',
                        that.dataDetail.Lists[that.rowindex].already_invoice_qty=data.releaseinvoiceqty,
                        that.dataDetail.Lists[that.rowindex].receive_line_total_amount=data.receive_line_total_amount,
                        that.dataDetail.Lists[that.rowindex].diff_amount='',
                        that.dataDetail.Lists[that.rowindex].order_line_total_amount=data.order_line_total_amount,
                        that.dataDetail.Lists[that.rowindex].tax_amount_diff= 0,
                        that.dataDetail.Lists[that.rowindex].net_unit_price = (that.dataDetail.Lists[that.rowindex].vender_net_unit_price* parseFloat(that.dataDetail.Head.exchange_rate)).toFixed(that.priceDigit)
                        that.dataDetail.Lists[that.rowindex].unit_price = (that.dataDetail.Lists[that.rowindex].vender_unit_price* parseFloat(that.dataDetail.Head.exchange_rate)).toFixed(that.priceDigit)
                        that.dataDetail.Lists[that.rowindex].vender_line_net_total_amount = (parseFloat(that.dataDetail.Lists[that.rowindex].net_unit_price) * parseFloat(that.dataDetail.Lists[that.rowindex].invoice_qty)).toFixed(that.amountDigit)
                        that.dataDetail.Lists[that.rowindex].line_net_total_amount = (that.dataDetail.Lists[that.rowindex].vender_line_net_total_amount * parseFloat(that.dataDetail.Head.exchange_rate)).toFixed(that.amountDigit)
                        that.dataDetail.Lists[that.rowindex].tax_amount = (that.dataDetail.Lists[that.rowindex].line_net_total_amount * that.dataDetail.Head.tax_rate / 100).toFixed(that.amountDigit)
                        that.dataDetail.Lists[that.rowindex].line_total_amount = ((parseFloat(that.dataDetail.Lists[that.rowindex].line_net_total_amount) + parseFloat(that.dataDetail.Lists[that.rowindex].tax_amount))).toFixed(that.amountDigit)
                        that.dataDetail.Lists[that.rowindex].diff_amount = (parseFloat(that.dataDetail.Lists[that.rowindex].line_net_total_amount) - parseFloat(that.dataDetail.Lists[that.rowindex].receive_line_total_amount)).toFixed(that.amountDigit)
                    }
                }
            },
            changeDataDetailData(row, type){
                let that = this
                that.rowindex = row.$index
                let token = JSON.parse(that.userData).token;
                if(type == 1){
                   /* let Invoice_qty = that.dataDetail.Lists[that.rowindex].invoice_qty
                    let Vender_Net_Unit_Price = parseFloat(that.dataDetail.Lists[that.rowindex].vender_net_unit_price)
                    that.dataDetail.Lists[that.rowindex].vender_line_net_total_amount = that.$processdata.mathRound2(Invoice_qty * Vender_Net_Unit_Price)
                    let Net_Unit_Price = parseFloat(that.dataDetail.Lists[that.rowindex].net_unit_price)
                    let TaxPrice =  Net_Unit_Price * (1 + parseFloat(that.dataDetail.Head.tax_rate) / 100)
                    let Line_Total_Amount = TaxPrice * Invoice_qty
                    that.dataDetail.Lists[that.rowindex].line_total_amount = that.$processdata.mathRound2(Line_Total_Amount)
                    let Tax_Amount = (TaxPrice - Net_Unit_Price) * Invoice_qty;
                    that.dataDetail.Lists[that.rowindex].tax_amount = that.$processdata.mathRound2(Tax_Amount)
                    let Line_Net_Total_Amount = Line_Total_Amount - Tax_Amount
                    that.dataDetail.Lists[that.rowindex].line_net_total_amount = that.$processdata.mathRound2(Line_Net_Total_Amount)*/
                    let Net_Unit_Price = parseFloat(that.dataDetail.Lists[that.rowindex].net_unit_price)
                    let Invoice_qty = parseFloat(that.dataDetail.Lists[that.rowindex].invoice_qty)
                    // 原币不含税金额
                    let Vender_Line_Net_Total_Amount = parseFloat(that.dataDetail.Lists[that.rowindex].vender_net_unit_price) * Invoice_qty
                    that.dataDetail.Lists[that.rowindex].vender_line_net_total_amount = Vender_Line_Net_Total_Amount.toFixed(that.amountDigit)
                    let VenderTaxPrice
                    let data = {
                        receive_order_no: that.dataDetail.Lists[that.rowindex].receive_order_no,
                        receive_order_line_no: that.dataDetail.Lists[that.rowindex].receive_order_line_no
                    }
                    $.ajax({
                        url: Common.Url + '/Pur/Invoice/GetPurOrderTaxPrice?token=' + token,
                        type: 'post',
                        async: false,
                        data: JSON.stringify(data),
                        contentType: 'application/json',
                        success: function (res) {
                            if (res.Success == 1) {
                                VenderTaxPrice = res.DataContent
                            }
                        }
                    });
                    let TaxAmount = 0
                    if(that.dataDetail.Head.currency_code != 'CNY'){
                        that.dataDetail.Lists[that.rowindex].tax_amount = TaxAmount
                    } else {
                        TaxAmount = (VenderTaxPrice * that.dataDetail.Head.exchange_rate - Net_Unit_Price) * Invoice_qty
                        that.dataDetail.Lists[that.rowindex].tax_amount = TaxAmount.toFixed(that.amountDigit)
                    }
                    
                    // 本币价税合计
                    let Line_Total_Amount = VenderTaxPrice * that.dataDetail.Head.exchange_rate * Invoice_qty
                    that.dataDetail.Lists[that.rowindex].line_total_amount = Line_Total_Amount.toFixed(that.amountDigit)
                    // 本币不含税金额
                    that.dataDetail.Lists[that.rowindex].line_net_total_amount = (parseFloat(that.dataDetail.Lists[that.rowindex].line_total_amount) - parseFloat(that.dataDetail.Lists[that.rowindex].tax_amount)).toFixed(that.amountDigit)
                    //入库单本币金额
                    let Unit_price
                    $.ajax({
                        url: Common.Url + '/Pur/Invoice/GetPurReceiveInTaxPrice?token=' + token,
                        type: 'post',
                        async: false,
                        data: JSON.stringify(data),
                        contentType: 'application/json',
                        success: function (res) {
                            if (res.Success == 1) {
                                Unit_price = res.DataContent
                            }
                        }
                    });
                    let Receive_line_total_amount = Unit_price * Invoice_qty
                    that.dataDetail.Lists[that.rowindex].receive_line_total_amount = Receive_line_total_amount.toFixed(that.amountDigit)
                    //差额
                    let diff_amount = parseFloat(that.dataDetail.Lists[that.rowindex].line_net_total_amount) - parseFloat(that.dataDetail.Lists[that.rowindex].receive_line_total_amount)
                    that.dataDetail.Lists[that.rowindex].diff_amount = diff_amount.toFixed(that.amountDigit)
                    //订单原币不含税金额
                    that.dataDetail.Lists[that.rowindex].order_line_total_amount = (Net_Unit_Price * Invoice_qty).toFixed(that.amountDigit)
                    //原币不含税差额=原币不含税金额-采购入库单上的单价/汇率*数量
                    let tprice
                    let TTotal
                    $.ajax({
                        url: Common.Url + 'Pur/Invoice/GetPurOrderPriceEx?token=' + token,
                        type: 'post',
                        async: false,
                        data: JSON.stringify(data),
                        contentType: 'application/json',
                        success: function (res) {
                            if (res.Success == 1) {
                                tprice = res.DataContent
                            }
                        }
                    });
                    TTotal = Invoice_qty * tprice;
                    that.dataDetail.Lists[that.rowindex].vender_net_amount_diff = (Vender_Line_Net_Total_Amount - TTotal).toFixed(that.amountDigit)
                    that.dataDetail.Lists[that.rowindex].tax_amount_diff=0;
                } else if(type == 2){
                    
                    that.dataDetail.Lists[that.rowindex].vender_net_unit_price = (parseFloat(that.dataDetail.Lists[that.rowindex].vender_line_net_total_amount) / parseFloat(that.dataDetail.Lists[that.rowindex].invoice_qty)).toFixed(that.priceDigit)
                    that.dataDetail.Lists[that.rowindex].vender_unit_price = (parseFloat(that.dataDetail.Lists[that.rowindex].vender_net_unit_price) * parseFloat(1+that.dataDetail.Head.tax_rate/100)).toFixed(that.priceDigit)
                    that.dataDetail.Lists[that.rowindex].net_unit_price = (that.dataDetail.Lists[that.rowindex].vender_net_unit_price * parseFloat(that.dataDetail.Head.exchange_rate)).toFixed(that.priceDigit)
                    that.dataDetail.Lists[that.rowindex].unit_price = (that.dataDetail.Lists[that.rowindex].net_unit_price *parseFloat(1+that.dataDetail.Head.tax_rate/100)).toFixed(that.priceDigit)

                    that.dataDetail.Lists[that.rowindex].line_net_total_amount = (that.dataDetail.Lists[that.rowindex].net_unit_price * parseFloat(that.dataDetail.Lists[that.rowindex].invoice_qty)).toFixed(that.amountDigit)
                    //本币税额
                    that.dataDetail.Lists[that.rowindex].tax_amount = (that.dataDetail.Lists[that.rowindex].net_unit_price * parseFloat(that.dataDetail.Head.tax_rate / 100) * that.dataDetail.Lists[that.rowindex].invoice_qty).toFixed(that.amountDigit)
    
                    //价税合计
                    that.dataDetail.Lists[that.rowindex].line_total_amount = (parseFloat(that.dataDetail.Lists[that.rowindex].line_net_total_amount) + parseFloat(that.dataDetail.Lists[that.rowindex].tax_amount)).toFixed(that.amountDigit)
                    let tprice
                    let TTotal
                    let data = {
                        receive_order_no: that.dataDetail.Lists[that.rowindex].receive_order_no,
                        receive_order_line_no: that.dataDetail.Lists[that.rowindex].receive_order_line_no
                    }
                    $.ajax({
                        url: Common.Url + 'Pur/Invoice/GetPurOrderPriceEx?token=' + token,
                        type: 'post',
                        async: false,
                        data: JSON.stringify(data),
                        contentType: 'application/json',
                        success: function (res) {
                            if (res.Success == 1) {
                                tprice = res.DataContent
                            }
                        }
                    });
                    TTotal = parseFloat(that.$processdata.mathRound2(that.dataDetail.Lists[that.rowindex].invoice_qty)) * tprice;
                    //原币不含税差额
                    that.dataDetail.Lists[that.rowindex].vender_net_amount_diff = (parseFloat(that.dataDetail.Lists[that.rowindex].vender_line_net_total_amount) - parseFloat(TTotal)).toFixed(that.amountDigit)
                    //本币税额差
                    that.dataDetail.Lists[that.rowindex].tax_amount_diff=0;
                } else if (type == 3){
                    //本币税额
                    let tax_amount = that.dataDetail.Lists[that.rowindex].net_unit_price * parseFloat(that.dataDetail.Head.tax_rate / 100) * that.dataDetail.Lists[that.rowindex].invoice_qty

                    that.dataDetail.Lists[that.rowindex].line_total_amount = (parseFloat(that.dataDetail.Lists[that.rowindex].line_net_total_amount) + parseFloat(that.dataDetail.Lists[that.rowindex].tax_amount)).toFixed(that.amountDigit)
                    //本币税额差
                    that.dataDetail.Lists[that.rowindex].tax_amount_diff = (tax_amount-that.dataDetail.Lists[that.rowindex].tax_amount).toFixed(that.amountDigit);
                }
            },
            getorderred(data){
                let that = this
                console.log(data)
                if(that.billmode == 1){
                    let orderArr = []
                    if(data.length > 0){
                        for(let i = 0;i<data.length;i++){
                            orderArr = [...orderArr, {order_no: data[i].order_no}]
                        }
                    } else {
                        orderArr.push(data)
                    }
                    let parm = {
                        vender_code: that.dataDetailRed.Head.vender_code,
                        Lists: orderArr
                    }
                    let loadingInstance = Loading.service(Common.maskoption1);
                    that.$http.urlpost('/Pur/Invoice/GetPurReturnListByOrderNo', parm, function (res) {
                        if (res.Success == 1) {
                            let resData = res.DataContent.Lists
                            that.dataDetailLineNoRed = 1
                            if(that.oneormorered == 1) {
                                for (let i = 0; i < that.dataDetailRed.Lists.length; i++) {
                                    if (that.dataDetailRed.Lists[i].line_no >= that.dataDetailLineNoRed) {
                                        that.dataDetailLineNoRed = that.dataDetailRed.Lists[i].line_no + 1
                                    }
                                }
                                for(let i = 0; i < resData.length;i++){
                                    that.dataDetailRed.Lists = [...that.dataDetailRed.Lists, {
                                        relation_invoice_no: resData[i].relation_invoice_no,
                                        line_no:that.dataDetailLineNoRed++,
                                        po_code:resData[i].po_code,
                                        receive_order_no:resData[i].receive_order_no,
                                        receive_order_line_no:resData[i].receive_order_line_no,
                                        part_code:resData[i].part_code,
                                        part_version:resData[i].part_version,
                                        part_name:resData[i].part_name,
                                        part_model:resData[i].part_model,
                                        part_spec:resData[i].part_spec,
                                        measure_unit:resData[i].measure_unit,
                                        invoice_qty:resData[i].invoice_qty,
                                        net_unit_price:resData[i].net_unit_price,
                                        unit_price:resData[i].unit_price,
                                        line_total_amount:resData[i].line_total_amount,
                                        line_net_total_amount:resData[i].line_net_total_amount,
                                        tax_amount:resData[i].tax_amount,
                                        local_tax_amount:resData[i].local_tax_amount,
                                        line_remark:resData[i].line_remark,
                                        vender_line_net_total_amount:resData[i].vender_line_net_total_amount,
                                        local_vender_line_net_total_amount:resData[i].local_vender_line_net_total_amount,
                                        po_line_id:resData[i].po_line_id,
                                        vender_net_unit_price:resData[i].vender_net_unit_price,
                                        vender_unit_price:resData[i].vender_unit_price,
                                        already_invoice_qty:resData[i].already_invoice_qty,
                                    }]
                                }
                            } else {
                                that.dataDetailRed.Lists[that.rowindexred].relation_invoice_no='',
                                    that.dataDetailRed.Lists[that.rowindexred].po_code=resData[0].po_code,
                                    that.dataDetailRed.Lists[that.rowindexred].receive_order_no=resData[0].receive_order_no,
                                    that.dataDetailRed.Lists[that.rowindexred].receive_order_line_no=resData[0].receive_order_line_no,
                                    that.dataDetailRed.Lists[that.rowindexred].part_code=resData[0].part_code,
                                    that.dataDetailRed.Lists[that.rowindexred].part_version=resData[0].part_version,
                                    that.dataDetailRed.Lists[that.rowindexred].part_name=resData[0].part_name,
                                    that.dataDetailRed.Lists[that.rowindexred].part_model=resData[0].part_model,
                                    that.dataDetailRed.Lists[that.rowindexred].part_spec=resData[0].part_spec,
                                    that.dataDetailRed.Lists[that.rowindexred].measure_unit=resData[0].measure_unit,
                                    that.dataDetailRed.Lists[that.rowindexred].invoice_qty=resData[0].invoice_qty,
                                    that.dataDetailRed.Lists[that.rowindexred].net_unit_price=resData[0].net_unit_price,
                                    that.dataDetailRed.Lists[that.rowindexred].unit_price=resData[0].unit_price,
                                    that.dataDetailRed.Lists[that.rowindexred].line_total_amount=resData[0].line_total_amount,
                                    that.dataDetailRed.Lists[that.rowindexred].line_net_total_amount=resData[0].line_net_total_amount,
                                    that.dataDetailRed.Lists[that.rowindexred].tax_amount=resData[0].tax_amount,
                                    that.dataDetailRed.Lists[that.rowindexred].local_tax_amount=resData[0].local_tax_amount,
                                    that.dataDetailRed.Lists[that.rowindexred].line_remark=resData[0].line_remark,
                                    that.dataDetailRed.Lists[that.rowindexred].vender_line_net_total_amount=resData[0].vender_line_net_total_amount,
                                    that.dataDetailRed.Lists[that.rowindexred].local_vender_line_net_total_amount=resData[0].local_vender_line_net_total_amount,
                                    that.dataDetailRed.Lists[that.rowindexred].po_line_id=resData[0].po_line_id,
                                    that.dataDetailRed.Lists[that.rowindexred].vender_net_unit_price=resData[0].vender_net_unit_price,
                                    that.dataDetailRed.Lists[that.rowindexred].vender_unit_price=resData[0].vender_unit_price,
                                    that.dataDetailRed.Lists[that.rowindexred].already_invoice_qty=resData[0].already_invoice_qty
                            }
                        }
                        loadingInstance.close()
                    });
                } else {
                    if(that.oneormorered == 1) {
                        console.log(data)
                        let newindex = that.dataDetailRed.Lists.length
                        that.dataDetailLineNoRed = 1
                        for (let i = 0; i < that.dataDetailRed.Lists.length; i++) {
                            if (that.dataDetailRed.Lists[i].line_no >= that.dataDetailLineNoRed) {
                                that.dataDetailLineNoRed = that.dataDetailRed.Lists[i].line_no + 1
                            }
                        }
                        for(let i = 0; i < data.length;i++){
                            that.dataDetailRed.Lists = [...that.dataDetailRed.Lists, {
                                relation_invoice_no: '',
                                line_no:that.dataDetailLineNoRed++,
                                receive_order_no:data[i].relation_order_no,
                                receive_order_line_no:data[i].line_no,
                                part_code:data[i].part_code,
                                part_version:data[i].part_version,
                                part_name:data[i].part_name,
                                part_model:data[i].part_model,
                                part_spec:data[i].part_spec,
                                measure_unit:data[i].pur_measure,
                                invoice_qty:data[i].pur_measure_actually_qty,
                                net_unit_price:0,
                                unit_price:0,
                                line_net_total_amount:'',
                                tax_amount:'',
                                line_total_amount:'',
                                vender_net_unit_price:'',
                                vender_unit_price:'',
                                vender_line_net_total_amount:'',
                                vender_net_amount_diff:'',
                                line_remark:'',
                                po_code:data[i].po_code,
                                po_line_id:'',
                                category_first:'',
                                category_second:'',
                                category_third:'',
                                negative_flag:'',
                                already_invoice_qty:data[i].releaseinvoiceqty,
                                receive_line_total_amount:'',
                                diff_amount:'',
                                order_line_total_amount:'',
                                stay_invoice_qty: data[i].stay_invoice_qty,
                                price: data[i].price
                            }]
                            for(let i = newindex;i<that.dataDetailRed.Lists.length;i++){
                                that.dataDetailRed.Lists[i].vender_net_unit_price =  (parseFloat(that.dataDetailRed.Lists[i].price) / (1 + parseFloat(that.dataDetailRed.Head.tax_rate) / 100)).toFixed(that.priceDigit)
                                that.dataDetailRed.Lists[i].vender_unit_price =  parseFloat(that.dataDetailRed.Lists[i].price).toFixed(that.priceDigit)
                                let TaxPrice = parseFloat(that.dataDetailRed.Lists[i].price) * parseFloat(that.dataDetailRed.Head.exchange_rate )
                                let NetPrice = TaxPrice / (1 + parseFloat(that.dataDetailRed.Head.tax_rate) / 100)
                                that.dataDetailRed.Lists[i].net_unit_price = NetPrice.toFixed(that.priceDigit)
                                that.dataDetailRed.Lists[i].unit_price = TaxPrice.toFixed(that.priceDigit)
                                that.dataDetailRed.Lists[i].vender_line_net_total_amount = (parseFloat(that.dataDetailRed.Lists[i].vender_net_unit_price) * parseFloat(that.dataDetailRed.Lists[i].stay_invoice_qty)).toFixed(that.amountDigit)
                                that.dataDetailRed.Lists[i].line_total_amount = (TaxPrice * parseFloat(that.dataDetailRed.Lists[i].stay_invoice_qty)).toFixed(that.amountDigit)
                                that.dataDetailRed.Lists[i].tax_amount = ((TaxPrice - NetPrice) * parseFloat(that.dataDetailRed.Lists[i].stay_invoice_qty)).toFixed(that.amountDigit)
                                that.dataDetailRed.Lists[i].line_net_total_amount = ((parseFloat(that.dataDetailRed.Lists[i].line_total_amount) - parseFloat(that.dataDetailRed.Lists[i].tax_amount))).toFixed(that.amountDigit)
                            }
                        }
                    } else {
                        that.dataDetailRed.Lists[that.rowindexred].relation_invoice_no= '',
                        that.dataDetailRed.Lists[that.rowindexred].receive_order_no=data.relation_order_no,
                        that.dataDetailRed.Lists[that.rowindexred].receive_order_line_no=data.line_no,
                        that.dataDetailRed.Lists[that.rowindexred].part_code=data.part_code,
                        that.dataDetailRed.Lists[that.rowindexred].part_version=data.part_version,
                        that.dataDetailRed.Lists[that.rowindexred].part_name=data.part_name,
                        that.dataDetailRed.Lists[that.rowindexred].part_model=data.part_model,
                        that.dataDetailRed.Lists[that.rowindexred].part_spec=data.part_spec,
                        that.dataDetailRed.Lists[that.rowindexred].measure_unit=data.pur_measure,
                        that.dataDetailRed.Lists[that.rowindexred].invoice_qty=data.pur_measure_actually_qty,
                        that.dataDetailRed.Lists[that.rowindexred].net_unit_price=0,
                        that.dataDetailRed.Lists[that.rowindexred].unit_price=0,
                        that.dataDetailRed.Lists[that.rowindexred].line_net_total_amount='',
                        that.dataDetailRed.Lists[that.rowindexred].tax_amount='',
                        that.dataDetailRed.Lists[that.rowindexred].line_total_amount='',
                        that.dataDetailRed.Lists[that.rowindexred].vender_net_unit_price='',
                        that.dataDetailRed.Lists[that.rowindexred].vender_unit_price='',
                        that.dataDetailRed.Lists[that.rowindexred].vender_line_net_total_amount='',
                        that.dataDetailRed.Lists[that.rowindexred].vender_net_amount_diff='',
                        that.dataDetailRed.Lists[that.rowindexred].line_remark='',
                        that.dataDetailRed.Lists[that.rowindexred].po_code=data.po_code,
                        that.dataDetailRed.Lists[that.rowindexred].po_line_id='',
                        that.dataDetailRed.Lists[that.rowindexred].category_first='',
                        that.dataDetailRed.Lists[that.rowindexred].category_second='',
                        that.dataDetailRed.Lists[that.rowindexred].category_third='',
                        that.dataDetailRed.Lists[that.rowindexred].negative_flag='',
                        that.dataDetailRed.Lists[that.rowindexred].already_invoice_qty=data.releaseinvoiceqty,
                        that.dataDetailRed.Lists[that.rowindexred].receive_line_total_amount='',
                        that.dataDetailRed.Lists[that.rowindexred].diff_amount='',
                        that.dataDetailRed.Lists[that.rowindexred].order_line_total_amount=''
                        that.dataDetailRed.Lists[that.rowindexred].stay_invoice_qty = data.stay_invoice_qty
                        that.dataDetailRed.Lists[that.rowindexred].price = data.price
                        that.dataDetailRed.Lists[that.rowindexred].vender_net_unit_price =  (parseFloat(that.dataDetailRed.Lists[that.rowindexred].price) / (1 + parseFloat(that.dataDetailRed.Head.tax_rate) / 100)).toFixed(that.priceDigit)
                        that.dataDetailRed.Lists[that.rowindexred].vender_unit_price = parseFloat(that.dataDetailRed.Lists[that.rowindexred].price) .toFixed(that.priceDigit)
                        let TaxPrice = parseFloat(that.dataDetailRed.Lists[that.rowindexred].price) * parseFloat(that.dataDetailRed.Head.exchange_rate)
                        let NetPrice = TaxPrice / (1 + parseFloat(that.dataDetailRed.Head.tax_rate) / 100)
                        that.dataDetailRed.Lists[that.rowindexred].net_unit_price = NetPrice.toFixed(that.amountDigit)
                        that.dataDetailRed.Lists[that.rowindexred].unit_price = TaxPrice.toFixed(that.amountDigit)
                        that.dataDetailRed.Lists[that.rowindexred].vender_line_net_total_amount = (parseFloat(that.dataDetailRed.Lists[that.rowindexred].vender_net_unit_price) * parseFloat(that.dataDetailRed.Lists[that.rowindexred].stay_invoice_qty)).toFixed(that.amountDigit)
                        that.dataDetailRed.Lists[that.rowindexred].line_total_amount = (TaxPrice * parseFloat(that.dataDetailRed.Lists[that.rowindexred].stay_invoice_qty)).toFixed(that.amountDigit)
                        that.dataDetailRed.Lists[that.rowindexred].tax_amount = ((TaxPrice - NetPrice) * parseFloat(that.dataDetailRed.Lists[that.rowindexred].stay_invoice_qty)).toFixed(that.amountDigit)
                        that.dataDetailRed.Lists[that.rowindexred].line_net_total_amount = ((parseFloat(that.dataDetailRed.Lists[that.rowindexred].line_total_amount) - parseFloat(that.dataDetailRed.Lists[that.rowindexred].tax_amount))).toFixed(that.amountDigit)
                    }
                }

            },
            changeDataDetailRedData(row, type){
                let that = this
                that.rowindexred = row.$index
                if(type == 1){
                    let Invoice_qty = that.dataDetailRed.Lists[that.rowindexred].invoice_qty
                    that.dataDetailRed.Lists[that.rowindexred].vender_line_net_total_amount = (that.dataDetailRed.Lists[that.rowindexred].vender_net_unit_price * Invoice_qty).toFixed(that.amountDigit)
                    let Net_Unit_Price = parseFloat(that.dataDetailRed.Lists[that.rowindexred].net_unit_price)
                    let TaxPrice =  Net_Unit_Price * (1 + parseFloat(that.dataDetailRed.Head.tax_rate) / 100)
                    that.dataDetailRed.Lists[that.rowindexred].line_total_amount = (Invoice_qty * TaxPrice).toFixed(that.amountDigit)
                    that.dataDetailRed.Lists[that.rowindexred].tax_amount = ((TaxPrice - Net_Unit_Price) * Invoice_qty).toFixed(that.amountDigit)
                    that.dataDetailRed.Lists[that.rowindexred].line_net_total_amount = ((that.dataDetailRed.Lists[that.rowindexred].line_total_amount - that.dataDetailRed.Lists[that.rowindexred].tax_amount)).toFixed(that.amountDigit)
                } else if(type == 2){
                    that.dataDetailRed.Lists[that.rowindexred].vender_net_unit_price = (parseFloat(that.dataDetailRed.Lists[that.rowindexred].vender_line_net_total_amount) / parseFloat(that.dataDetailRed.Lists[that.rowindexred].invoice_qty)).toFixed(that.priceDigit)
                    that.dataDetailRed.Lists[that.rowindexred].vender_unit_price = (parseFloat(that.dataDetailRed.Lists[that.rowindexred].vender_net_unit_price * (1 + parseFloat(that.dataDetailRed.Head.tax_rate) / 100))).toFixed(that.priceDigit)
                    that.dataDetailRed.Lists[that.rowindexred].net_unit_price = (that.dataDetailRed.Lists[that.rowindexred].vender_net_unit_price * parseFloat(that.dataDetailRed.Head.exchange_rate)).toFixed(that.priceDigit)
                    that.dataDetailRed.Lists[that.rowindexred].unit_price = (parseFloat(that.dataDetailRed.Lists[that.rowindexred].net_unit_price * (1 + parseFloat(that.dataDetailRed.Head.tax_rate) / 100))).toFixed(that.priceDigit)
                    that.dataDetailRed.Lists[that.rowindexred].line_net_total_amount = (that.dataDetailRed.Lists[that.rowindexred].net_unit_price * parseFloat(that.dataDetailRed.Lists[that.rowindexred].invoice_qty)).toFixed(that.amountDigit)
                    that.dataDetailRed.Lists[that.rowindexred].tax_amount = (that.dataDetailRed.Lists[that.rowindexred].net_unit_price * parseFloat(that.dataDetailRed.Head.tax_rate / 100) * that.dataDetailRed.Lists[that.rowindexred].invoice_qty).toFixed(that.amountDigit)
                    that.dataDetailRed.Lists[that.rowindexred].line_total_amount = (parseFloat(that.dataDetailRed.Lists[that.rowindexred].line_net_total_amount) + parseFloat(that.dataDetailRed.Lists[that.rowindexred].tax_amount)).toFixed(that.amountDigit)
                } else if (type == 3){
                    that.dataDetailRed.Lists[that.rowindexred].line_total_amount = (parseFloat(that.dataDetailRed.Lists[that.rowindexred].line_net_total_amount) + parseFloat(that.dataDetailRed.Lists[that.rowindexred].tax_amount)).toFixed(that.amountDigit)
                }
            },
            batchDel(){
                let that = this;
                this.$confirm(that.$t('getapi[8573]'), that.$t('getapi[194]'), {//'确定删除数据?'
                    confirmButtonText: that.$t('getapi[1146]'),
                    cancelButtonText: that.$t('getapi[2054]'),
                    type: 'warning'
                })
                    .then(() => {
                        let parm = {
                            invoice_no: that.dataDetail.Head.invoice_no,
                            concurrent_time: that.dataDetail.Head.concurrent_time,
                            billmode: that.billmode,
                            invoice_date:that.dataDetail.Head.invoice_date,
                            create_date:that.dataDetail.Head.create_date,
                            virtual_flag:that.dataDetail.Head.virtual_flag,
                            Lists: [],
                            LangType: that.$processdata.getLang(),
                        };
                        if(that.billmode == 1){
                            for (let i = that.selectDataDetail.length - 1; i >= 0; i--) {
                                let receive_order_no = that.selectDataDetail[i].receive_order_no;
                                for (let j = that.dataDetail.Lists.length - 1; j >= 0; j--) {
                                    if (that.dataDetail.Lists[j].receive_order_no != receive_order_no) {
                                        continue;
                                    }

                                    if (that.dataDetail.Lists[j].relation_invoice_no != '' && null != that.dataDetail.Lists[j].relation_invoice_no) {
                                        parm.Lists.push({
                                            receive_order_no:that.dataDetail.Lists[j].receive_order_no,
                                            line_no: that.dataDetail.Lists[j].line_no,
                                            receive_order_line_no:that.dataDetail.Lists[j].receive_order_line_no,
                                        });
                                    }
                                    that.dataDetail.Lists.splice(j, 1);
                                }
                            }
                        } else {
                            for (let i = that.selectDataDetail.length - 1; i >= 0; i--) {
                                that.dataDetail.Lists.splice(that.selectDataDetail[i].index, 1);
                                if(that.selectDataDetail[i].relation_invoice_no!="" && null!=that.selectDataDetail[i].relation_invoice_no){
                                    let datatmp = {
                                        relation_invoice_no: that.selectDataDetail[i].relation_invoice_no,
                                        receive_order_no:that.selectDataDetail[i].receive_order_no,
                                        line_no: that.selectDataDetail[i].line_no,
                                        receive_order_line_no:that.selectDataDetail[i].receive_order_line_no,
                                    }
                                    parm.Lists.push(datatmp);
                                }
                            }
                        }
                        if(that.dataDetail.Lists.length == 0 && that.addoredit != 0){
                            that.$confirm(that.$t('getapi[8605]'), that.$t('getapi[194]'), {//入库单都已删除，是否要删除发票主体
                                confirmButtonText: that.$t('getapi[1146]'),
                                cancelButtonText: that.$t('getapi[2054]'),
                                type: 'warning'
                            })
                                .then(() => {
                                    that.del()
                                })
                                .catch(() => {
                                    if(parm.Lists.length>0){
                                        that.btn.batchdel = false
                                        that.$http.urlpost('/Pur/Invoice/DelLinePurInvoice', parm, function (res) {
                                            if (res.Success == 1) {
                                                that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                                                that.getDetail(that.code)
                                            } else {
                                                that.getDetail(that.code)
                                            }
                                            that.btn.batchdel = true
                                        });
                                    }
                                });
                        } else {
                            if(parm.Lists.length>0){
                                that.btn.batchdelred = false
                                that.$http.urlpost('/Pur/Invoice/DelLinePurInvoice', parm, function (res) {
                                    if (res.Success == 1) {
                                        that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                                        that.getDetail(that.code)
                                    }
                                    that.btn.batchdelred = true
                                });
                            }
                        }
                    })
                    .catch(() => {
                        this.$message({
                            type: 'info',
                            message: that.$t('getapi[8574]')
                        });
                    });
            },
            batchDelRed(){
                let that = this;
                this.$confirm(that.$t('getapi[8573]'), that.$t('getapi[194]'), {//'确定删除数据?'
                    confirmButtonText: that.$t('getapi[1146]'),
                    cancelButtonText: that.$t('getapi[2054]'),
                    type: 'warning'
                })
                    .then(() => {
                        let parm = {
                            invoice_no: that.dataDetailRed.Head.invoice_no,
                            concurrent_time: that.dataDetailRed.Head.concurrent_time,
                            virtual_flag: that.dataDetailRed.Head.virtual_flag,
                            billmode: that.billmode,
                            tax_rate: that.dataDetailRed.Head.tax_rate,
                            Lists: [],
                            LangType: that.$processdata.getLang(),
                        };
                        if(that.billmode == 1 ){
                            /*let data = []
                            data = that.dataDetailRed.Lists.filter(item => {
                                return that.selectDataDetailRed.every(item2 => {
                                    return item2.receive_order_no == item.receive_order_no
                                });
                            });
                            for (let i = data.length - 1; i >= 0; i--) {
                                that.dataDetailRed.Lists.splice(data[i].index, 1);
                                if(data[i].relation_invoice_no!="" && null != data[i].relation_invoice_no){
                                    let datatmp = {
                                        receive_order_no:data[i].receive_order_no,
                                        line_no: data[i].line_no,
                                    }
                                    parm.Lists.push(datatmp);
                                }
                            }*/
                            for (let i = that.selectDataDetailRed.length - 1; i >= 0; i--) {
                                let receive_order_no = that.selectDataDetailRed[i].receive_order_no;
                                for (let j = that.dataDetailRed.Lists.length - 1; j >= 0; j--) {
                                    if (that.dataDetailRed.Lists[j].receive_order_no != receive_order_no) {
                                        continue;
                                    }

                                    if (that.dataDetailRed.Lists[j].relation_invoice_no != '' && null != that.dataDetailRed.Lists[j].relation_invoice_no) {
                                        parm.Lists.push({
                                            receive_order_no:that.dataDetailRed.Lists[j].receive_order_no,
                                            line_no: that.dataDetailRed.Lists[j].line_no,
                                        });
                                    }
                                    that.dataDetailRed.Lists.splice(j, 1);
                                }
                            }
                        } else {
                            for (let i = that.selectDataDetailRed.length - 1; i >= 0; i--) {
                                that.dataDetailRed.Lists.splice(that.selectDataDetailRed[i].index, 1);
                                if(that.selectDataDetailRed[i].relation_invoice_no!="" && null!=that.selectDataDetailRed[i].relation_invoice_no){
                                    let datatmp = {
                                        relation_invoice_no: that.selectDataDetailRed[i].relation_invoice_no,
                                        receive_order_no:that.selectDataDetailRed[i].receive_order_no,
                                        line_no: that.selectDataDetailRed[i].line_no,
                                    }
                                    parm.Lists.push(datatmp);
                                }
                            }
                        }
                        if(that.dataDetailRed.Lists.length == 0 && that.addoredit != 0){
                            that.$confirm(that.$t('getapi[8605]'), that.$t('getapi[194]'), {//入库单都已删除，是否要删除发票主体
                                confirmButtonText: that.$t('getapi[1146]'),
                                cancelButtonText: that.$t('getapi[2054]'),
                                type: 'warning'
                            })
                                .then(() => {
                                    that.del()
                                })
                                .catch(() => {
                                    if(parm.Lists.length>0){
                                        that.$http.urlpost('/Pur/Invoice/DelRedLinePurInvoice', parm, function (res) {
                                            if (res.Success == 1) {
                                                that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                                                that.getDetailRed(that.code)
                                            } else {
                                                that.getDetailRed(that.code)
                                            }
                                        });
                                    }
                                });
                        } else {
                            if(parm.Lists.length>0){
                                that.$http.urlpost('/Pur/Invoice/DelRedLinePurInvoice', parm, function (res) {
                                    if (res.Success == 1) {
                                        that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                                        that.getDetailRed(that.code)
                                    }
                                });
                            }
                        }

                    })
                    .catch(() => {
                        this.$message({
                            type: 'info',
                            message: that.$t('getapi[8574]')
                        });
                    });
            },
            //获取采购订单
            selectSupplier() {
                let that = this;
                if(that.negative_flag == 0){
                    if(that.dataDetail.Lists.length>0){
                        that.$message.warning(that.$t('getapi[13144]'));
                        return;
                    }

                    if(that.dataDetail.OtherCostList.length>0){
                        that.$message.warning(that.$t('getapi[13145]'));
                        return;
                    }
                }
                else{
                    if(that.dataDetailRed.Lists.length>0){
                        that.$message.warning(that.$t('getapi[13144]'));
                        return;
                    }
                }

                that.$refs.supplier.clearInput(true);
            },
            // 获取订单信息
            getsupplier(data) {
                let that = this;
                console.log(data)
                if(that.negative_flag == 0){
                    let balancemode_name = data.balancemode_name
                    for(let i=0;i<that.balanceMode.length;i++){
                        if(that.balanceMode[i].Name == balancemode_name){
                            that.dataDetail.Head.balance_mode = that.balanceMode[i].Code
                        }
                    }
                    that.dataDetail.Head.vender_code = data.vender_code
                    that.dataDetail.Head.vender_name = data.vender_name
                    let parm = {
                        Code: that.dataDetail.Head.vender_code
                    }
                    that.$http.urlpost('/Pur/Invoice/GetSupplyFinanceInfo', parm, function (res) {
                        if (res.Success == 1) {
                            if(res.DataContent.DataList.length > 0){
                                let resData = res.DataContent.DataList[0]
                                that.dataDetail.Head.payment_period = resData.checkout_cycle
                                that.dataDetail.Head.tax_code = resData.tax_code
                                that.dataDetail.Head.tax_rate = resData.tax_rate
                                that.dataDetail.Head.currency_code = resData.currency_code
                                that.dataDetail.Head.bank_account_name = resData.bank_account_name
                                that.dataDetail.Head.bank_account_number = resData.bank_account_number
                                that.dataDetail.Head.tax_number = resData.tax_number
                                that.dataDetail.Head.exchange_rate = resData.exchange_rate
                            }
                        }
                    });
                } else {
                    let balancemode_name = data.balancemode_name
                    for(let i=0;i<that.balanceMode.length;i++){
                        if(that.balanceMode[i].Name == balancemode_name){
                            that.dataDetailRed.Head.balance_mode = that.balanceMode[i].Code
                        }
                    }
                    that.dataDetailRed.Head.vender_code = data.vender_code
                    that.dataDetailRed.Head.vender_name = data.vender_name
                    let parm = {
                        Code: that.dataDetailRed.Head.vender_code
                    }
                    that.$http.urlpost('/Pur/Invoice/GetSupplyFinanceInfo', parm, function (res) {
                        if (res.Success == 1) {
                            if(res.DataContent.DataList.length > 0){
                                let resData = res.DataContent.DataList[0]
                                that.dataDetailRed.Head.payment_period = resData.checkout_cycle
                                that.dataDetailRed.Head.tax_code = resData.tax_code
                                that.dataDetailRed.Head.tax_rate = resData.tax_rate
                                that.dataDetailRed.Head.currency_code = resData.currency_code
                                that.dataDetailRed.Head.bank_account_name = resData.bank_account_name
                                that.dataDetailRed.Head.bank_account_number = resData.bank_account_number
                                that.dataDetailRed.Head.tax_number = resData.tax_number
                                that.dataDetailRed.Head.exchange_rate = resData.exchange_rate
                            }
                        }
                    });
                }

            },
            getSupplyFinanceInfo(val){
                let that = this
                let parm = {
                    Code: val
                }
                that.$http.urlpost('/Pur/Invoice/GetSupplyFinanceInfo', parm, function (res) {
                    if (res.Success == 1) {
                        if(res.DataContent.DataList.length > 0){
                            let resData = res.DataContent.DataList[0]
                            that.dataDetail.Head.payment_period = resData.checkout_cycle
                            that.dataDetail.Head.tax_code = resData.tax_code
                            that.dataDetail.Head.tax_rate = resData.tax_rate
                            that.dataDetail.Head.currency_code = resData.currency_code
                            that.dataDetail.Head.bank_account_name = resData.bank_account_name
                            that.dataDetail.Head.bank_account_number = resData.bank_account_number
                            that.dataDetail.Head.tax_number = resData.tax_number
                            that.dataDetail.Head.exchange_rate = resData.exchange_rate
                            that.dataDetail.Head.balance_mode = resData.balancemode_name
                        }
                    }
                });
            },
            //获取费用项名称
            selectChargeName(row) {
                let that = this;
                let  param =  {
                    billmode: that.billmode,
                    vendcode: that.dataDetail.Head.vender_code
                }
                if(row == ''){
                    that.oneormore = 1
                    that.$refs.charge.clearInput(true,param);
                }  else {
                    that.oneormore = 2
                    that.rowindexother = row.$index;
                    that.$refs.chargesingle.clearInput(true,param);
                }

            },
            // 获取订单信息
            getChargeName(data) {
                let that = this;
                if(that.oneormore == 1){
                    console.log(data)
                    that.dataDetailLineNoCost = 1
                    for (let i = 0; i < that.dataDetail.OtherCostList.length; i++) {
                        if (that.dataDetail.OtherCostList[i].line_no >= that.dataDetailLineNoCost) {
                            that.dataDetailLineNoCost = that.dataDetail.OtherCostList[i].line_no + 1
                        }
                    }
                    for(let i = 0;i<data.length;i++){
                        that.dataDetail.OtherCostList = [...that.dataDetail.OtherCostList,{
                            relation_invoice_no:'',
                            line_no: that.dataDetailLineNoCost++,
                            charge_name: data[i].Doc_No,
                            net_unit_price: data[i].NoTaxed_Cost,
                            unit_price: data[i].Actual_Cost,
                            charge_qty: 1,
                            net_total_amount: (data[i].NoTaxed_Cost != '' && data[i].NoTaxed_Cost != null)?(data[i].NoTaxed_Cost * 1):'',
                            base_net_unit_price: (data[i].NoTaxed_Cost != '' && data[i].NoTaxed_Cost != null)?(data[i].NoTaxed_Cost * that.dataDetail.Head.exchange_rate):'',
                            base_net_total_amount: (data[i].NoTaxed_Cost != '' && data[i].NoTaxed_Cost != null)?(data[i].NoTaxed_Cost * that.dataDetail.Head.exchange_rate * 1):'',
                            total_amount: (data[i].Actual_Cost != '' && data[i].Actual_Cost != null)?(data[i].Actual_Cost * 1):'',
                            base_unit_price: (data[i].Actual_Cost != '' && data[i].Actual_Cost != null)?(data[i].Actual_Cost * that.dataDetail.Head.exchange_rate):'',
                            base_total_amount: (data[i].Actual_Cost != '' && data[i].Actual_Cost != null)?(data[i].Actual_Cost * that.dataDetail.Head.exchange_rate * 1):''
                        }]
                    }
                } else {
                    console.log(data)
                    that.dataDetail.OtherCostList[that.rowindexother].charge_name = data.Doc_No
                    that.dataDetail.OtherCostList[that.rowindexother].net_unit_price = data.NoTaxed_Cost
                    that.dataDetail.OtherCostList[that.rowindexother].unit_price = data.Actual_Cost
                    that.dataDetail.OtherCostList[that.rowindexother].charge_qty = 1
                    if(that.dataDetail.OtherCostList[that.rowindexother].charge_qty != '' && that.dataDetail.OtherCostList[that.rowindexother].net_unit_price != ''){
                        that.dataDetail.OtherCostList[that.rowindexother].net_total_amount = that.dataDetail.OtherCostList[that.rowindexother].charge_qty * that.dataDetail.OtherCostList[that.rowindexother].net_unit_price
                        that.dataDetail.OtherCostList[that.rowindexother].base_net_unit_price = that.dataDetail.OtherCostList[that.rowindexother].net_unit_price * that.dataDetail.Head.exchange_rate
                        that.dataDetail.OtherCostList[that.rowindexother].base_net_total_amount = that.dataDetail.OtherCostList[that.rowindexother].charge_qty * that.dataDetail.OtherCostList[that.rowindexother].base_net_unit_price
                    }
                    if(that.dataDetail.OtherCostList[that.rowindexother].charge_qty != '' && that.dataDetail.OtherCostList[that.rowindexother].unit_price != ''){
                        that.dataDetail.OtherCostList[that.rowindexother].total_amount = that.dataDetail.OtherCostList[that.rowindexother].charge_qty * that.dataDetail.OtherCostList[that.rowindexother].unit_price
                        that.dataDetail.OtherCostList[that.rowindexother].base_unit_price = that.dataDetail.OtherCostList[that.rowindexother].unit_price * that.dataDetail.Head.exchange_rate
                        that.dataDetail.OtherCostList[that.rowindexother].base_total_amount = that.dataDetail.OtherCostList[that.rowindexother].charge_qty * that.dataDetail.OtherCostList[that.rowindexother].base_unit_price
                    }
                }
            },
            // 新增费用明细行
            addOtherCostList(){
                let that = this
                that.dataDetailLineNoCost = 1
                for (let i = 0; i < that.dataDetail.OtherCostList.length; i++) {
                    if (that.dataDetail.OtherCostList[i].line_no >= that.dataDetailLineNoCost) {
                        that.dataDetailLineNoCost = that.dataDetail.OtherCostList[i].line_no + 1
                    }
                }
                that.dataDetail.OtherCostList = [...that.dataDetail.OtherCostList,{
                    relation_invoice_no: '',
                    line_no: that.dataDetailLineNoCost++,
                    charge_name: '',
                    net_unit_price: '',
                    unit_price: '',
                    net_total_amount: '',
                    total_amount: '',
                    charge_qty: '',
                    base_net_unit_price: '',
                    base_unit_price: '',
                    base_net_total_amount: '',
                    base_total_amount: ''
                }]
            },
            changechargedata(row){
                let that = this
                let index = row.$index
                if(that.dataDetail.OtherCostList[index].charge_qty == ''){
                    that.net_total_amount = 0
                    that.total_amount = 0
                    that.base_net_unit_price = 0
                    that.base_unit_price = 0
                    that.base_net_total_amount = 0
                    that.base_total_amount = 0
                }
                if(that.dataDetail.OtherCostList[index].charge_qty != '' && that.dataDetail.OtherCostList[index].net_unit_price != ''){
                    that.dataDetail.OtherCostList[index].net_total_amount = that.dataDetail.OtherCostList[index].charge_qty * that.dataDetail.OtherCostList[index].net_unit_price
                    that.dataDetail.OtherCostList[index].base_net_unit_price = that.dataDetail.OtherCostList[index].net_unit_price * that.dataDetail.Head.exchange_rate
                    that.dataDetail.OtherCostList[index].base_net_total_amount = that.dataDetail.OtherCostList[index].charge_qty * that.dataDetail.OtherCostList[index].base_net_unit_price
                }
                if(that.dataDetail.OtherCostList[index].charge_qty != '' && that.dataDetail.OtherCostList[index].unit_price != ''){
                    that.dataDetail.OtherCostList[index].total_amount = that.dataDetail.OtherCostList[index].charge_qty * that.dataDetail.OtherCostList[index].unit_price
                    that.dataDetail.OtherCostList[index].base_unit_price = that.dataDetail.OtherCostList[index].unit_price * that.dataDetail.Head.exchange_rate
                    that.dataDetail.OtherCostList[index].base_total_amount = that.dataDetail.OtherCostList[index].charge_qty * that.dataDetail.OtherCostList[index].base_unit_price
                }
            },
            batchDelOtherCostList(){
                let that = this;
                this.$confirm(that.$t('getapi[8573]'), that.$t('getapi[194]'), {//'确定删除数据?'
                    confirmButtonText: that.$t('getapi[1146]'),
                    cancelButtonText: that.$t('getapi[2054]'),
                    type: 'warning'
                })
                    .then(() => {
                        let parm = {
                            invoice_no: that.dataDetail.Head.invoice_no,
                            concurrent_time: that.dataDetail.Head.concurrent_time,
                            Lists: []
                        };
                        for (let i = that.selectDataDetailCost.length - 1; i >= 0; i--) {
                            that.dataDetail.OtherCostList.splice(that.selectDataDetailCost[i].index, 1);
                            if(that.selectDataDetailCost[i].relation_invoice_no !=""){
                                let datatmp = {
                                    relation_invoice_no: that.selectDataDetailCost[i].relation_invoice_no,
                                    line_no: that.selectDataDetailCost[i].line_no,
                                }
                                parm.Lists.push(datatmp);
                            }
                        }
                        if(parm.Lists.length>0){
                            that.$http.urlpost('/Pur/Invoice/DelCostLinePurInvoice', parm, function (res) {
                                if (res.Success == 1) {
                                    that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                                    that.getDetail(that.dataDetail.Head.invoice_no) ;
                                }
                            });
                        }
                    })
                    .catch(() => {
                        this.$message({
                            type: 'info',
                            message: that.$t('getapi[8574]')
                        });
                    });
            },
            checkAuditTime(){
                let that = this
                let parm = {
                }
                that.$http.urlpost('/Finance/Invoice/CheckAuditTime', parm, function (res) {
                    if (res.Success == 1) {
                        that.auditCheckData = res.DataContent
                        that.auditCheckTrue()
                    } else if(res.Success == 2){
                        that.auditCheckData = res.DataContent
                        that.auditCheckData.YearMonth = that.auditCheckData.SysYM
                        that.auditCheckVisiable = true
                    }
                });
            },
            auditCheckFalse(){
                let that = this
                that.auditCheckData.YearMonth = that.auditCheckData.DBYM
                that.auditCheckVisiable = false
                if(that.beforeEventName == 'auditPurInvoice'){
                    that.auditPurInvoice()
                } else if(that.beforeEventName == 'batchAudit'){
                    that.batchAudit()
                } else if(that.beforeEventName == 'auditPurInvoiceRed'){
                    that.auditPurInvoiceRed()
                } else if(that.beforeEventName == 'rAuditPurInvoiceRed'){
                    that.rAuditPurInvoiceRed()
                }
            },
            auditCheckTrue(){
                let that = this
                that.auditCheckVisiable = false
                if(that.beforeEventName == 'auditPurInvoice'){
                    that.auditPurInvoice()
                } else if(that.beforeEventName == 'batchAudit'){
                    that.batchAudit()
                } else if(that.beforeEventName == 'auditPurInvoiceRed'){
                    that.auditPurInvoiceRed()
                } else if(that.beforeEventName == 'rAuditPurInvoiceRed'){
                    that.rAuditPurInvoiceRed()
                }
            },
            beforeAuditPurInvoice(){
                let that = this
                if(that.negative_flag == 0 ){
                    that.beforeEventName = 'auditPurInvoice'
                } else {
                    that.beforeEventName = 'auditPurInvoiceRed'
                }
                that.checkAuditTime()
            },
            // 审核
            auditPurInvoice(){
                let that = this
                let parm = {
                    invoice_no: that.dataDetail.Head.invoice_no,
                    concurrent_time: that.dataDetail.Head.concurrent_time,
                    invoice_date:that.dataDetail.Head.invoice_date,
                    create_date:that.dataDetail.Head.create_date,
                    virtual_flag:that.dataDetail.Head.virtual_flag,
                    yearmonth: that.auditCheckData.YearMonth,
                    LangType: that.$processdata.getLang(),
                }
                that.$http.urlpost('/Pur/Invoice/AuditPurInvoice', parm, function (res) {
                    if (res.Success == 1) {
                        that.$message.success(that.$processdata.explainCallbackMsg(res.Msg))
                        that.getDetail(that.code)
                    }
                });
            },
            // 审核 - 红字
            auditPurInvoiceRed(){
                let that = this
                let arr = []
                for(let i = 0;i<that.dataDetailRed.Lists;i++){
                    arr = [...arr,{
                        receive_order_no: that.dataDetailRed.Lists[i].receive_order_no
                    }]
                }
                let parm = {
                    invoice_no: that.dataDetailRed.Head.invoice_no,
                    concurrent_time: that.dataDetailRed.Head.concurrent_time,
                    yearmonth: that.auditCheckData.YearMonth,
                    tax_rate: that.dataDetailRed.Head.tax_rate,
                    virtual_flag: that.dataDetailRed.Head.virtual_flag,
                    Lists: arr
                }
                that.$http.urlpost('/Pur/Invoice/RedAuditPurInvoice', parm, function (res) {
                    if (res.Success == 1) {
                        that.$message.success(that.$processdata.explainCallbackMsg(res.Msg))
                        that.getDetailRed(that.code)
                    }
                });
            },
            // 反审核
            rAuditPurInvoice(){
                let that = this
                let parm = {
                    invoice_no: that.dataDetail.Head.invoice_no,
                    concurrent_time: that.dataDetail.Head.concurrent_time,
                    audit_date: that.dataDetail.Head.audit_date,
                    LangType:that.$processdata.getLang()
                }
                that.$http.urlpost('/Pur/Invoice/RAuditPurInvoice', parm, function (res) {
                    if (res.Success == 1) {
                        that.$message.success(that.$processdata.explainCallbackMsg(res.Msg))
                        that.getDetail(that.code)
                    }
                });
            },
            beforeRAuditPurInvoiceRed(){
                let that = this
                that.beforeEventName = 'rAuditPurInvoiceRed'
                that.checkAuditTime()
            },
            // 反审核-红字
            rAuditPurInvoiceRed(){
                let that = this
                let arr = []
                for(let i = 0;i<that.dataDetailRed.Lists;i++){
                    arr = [...arr,{
                        receive_order_no: that.dataDetailRed.Lists[i].receive_order_no
                    }]
                }
                let parm = {
                    invoice_no: that.dataDetailRed.Head.invoice_no,
                    concurrent_time: that.dataDetailRed.Head.concurrent_time,
                    yearmonth: that.auditCheckData.YearMonth,
                    audit_period: that.dataDetailRed.Head.audit_period,
                    virtual_flag: that.dataDetailRed.Head.virtual_flag,
                    Lists: arr,
                    LangType: that.$processdata.getLang(),
                }
                that.$http.urlpost('/Pur/Invoice/RRedAuditPurInvoice', parm, function (res) {
                    if (res.Success == 1) {
                        that.$message.success(that.$processdata.explainCallbackMsg(res.Msg))
                        that.getDetailRed(that.code)
                    }
                });
            },
            // 记账
            balancePurInvoice(){
                let that = this
                let parm = {
                    invoice_no: that.dataDetail.Head.invoice_no,
                    concurrent_time: that.dataDetail.Head.concurrent_time,
                }
                that.$http.urlpost('/Pur/Invoice/BalancePurInvoice', parm, function (res) {
                    if (res.Success == 1) {
                        that.$message.success(that.$processdata.explainCallbackMsg(res.Msg))
                        that.getDetail(that.code)
                    }
                });
            },
            // 记账 - 红字
            balancePurInvoiceRed(){
                let that = this
                let parm = {
                    invoice_no: that.dataDetailRed.Head.invoice_no,
                    concurrent_time: that.dataDetailRed.Head.concurrent_time,
                }
                that.$http.urlpost('/Pur/Invoice/RedBalancePurInvoice', parm, function (res) {
                    if (res.Success == 1) {
                        that.$message.success(that.$processdata.explainCallbackMsg(res.Msg))
                        that.getDetailRed(that.code)
                    }
                });
            },
            // 反记账
            rBalancePurInvoice(){
                let that = this
                let parm = {
                    invoice_no: that.dataDetail.Head.invoice_no,
                    concurrent_time: that.dataDetail.Head.concurrent_time,
                }
                that.$http.urlpost('/Pur/Invoice/RBalancePurInvoice', parm, function (res) {
                    if (res.Success == 1) {
                        that.$message.success(that.$processdata.explainCallbackMsg(res.Msg))
                        that.getDetail(that.code)
                    }
                });
            },
            // 反记账 - 红字
            rBalancePurInvoiceRed(){
                let that = this
                let parm = {
                    invoice_no: that.dataDetailRed.Head.invoice_no,
                    concurrent_time: that.dataDetailRed.Head.concurrent_time,
                }
                that.$http.urlpost('/Pur/Invoice/RRedBalancePurInvoice', parm, function (res) {
                    if (res.Success == 1) {
                        that.$message.success(that.$processdata.explainCallbackMsg(res.Msg))
                        that.getDetailRed(that.code)
                    }
                });
            },
            beforeSetRatePurInvoice(){
                let that = this
                that.visRate = true
                if(that.negative_flag == 0){
                    that.exchange_rate = that.dataDetail.Head.exchange_rate
                } else {
                    that.exchange_rate = that.dataDetailRed.Head.exchange_rate
                }
            },
            // 变更汇率
            setRatePurInvoice(){
                let that = this
                let parm = {}
                if(that.negative_flag == 0){
                    parm = {
                        invoice_no: that.dataDetail.Head.invoice_no,
                        concurrent_time: that.dataDetail.Head.concurrent_time,
                        exchange_rate: that.exchange_rate,
                        tax_rate: that.dataDetail.Head.tax_rate,
                        frmflg: 1
                    }
                } else {
                    parm = {
                        invoice_no: that.dataDetailRed.Head.invoice_no,
                        concurrent_time: that.dataDetailRed.Head.concurrent_time,
                        exchange_rate: that.dataDetailRed.Head.exchange_rate,
                        tax_rate: that.dataDetailRed.tax_rate,
                        frmflg: 1
                    }
                }
                that.$http.urlpost('/Finance/Invoice/SetRate', parm, function (res) {
                    if (res.Success == 1) {
                        that.$message.success(that.$processdata.explainCallbackMsg(res.Msg))
                        that.visRate = false
                        if(that.negative_flag == 0){
                            that.getDetail(that.code)
                        } else {
                            that.getDetailRed(that.code)
                        }
                    }
                });
            },
            beforeSetTaxRatePurInvoice(){
                let that = this
                that.visTaxRate = true
                if(that.negative_flag == 0){
                    that.tax_rate = that.dataDetail.Head.tax_rate
                } else {
                    that.tax_rate = that.dataDetailRed.Head.tax_rate
                }
            },
            // 变更税率
            setTaxRatePurInvoice(){
                let that = this
                let parm = {}
                if(that.negative_flag == 0){
                    parm = {
                        invoice_no: that.dataDetail.Head.invoice_no,
                        concurrent_time: that.dataDetail.Head.concurrent_time,
                        order_type: 'pur',
                        tax_rate: that.tax_rate,
                    }
                } else {
                    parm = {
                        invoice_no: that.dataDetailRed.Head.invoice_no,
                        concurrent_time: that.dataDetailRed.Head.concurrent_time,
                        order_type: 'pur_n',
                        tax_rate: that.tax_rate,
                    }
                }
                that.$http.urlpost('/Finance/Invoice/SetTaxRate', parm, function (res) {
                    if (res.Success == 1) {
                        that.$message.success(that.$processdata.explainCallbackMsg(res.Msg))
                        that.visTaxRate = false
                        if(that.negative_flag == 0){
                            that.getDetail(that.code)
                        } else {
                            that.getDetailRed(that.code)
                        }
                    }
                });
            },
            beforeSetChangeTaxRatePurInvoice(){
                let that = this
                that.visChangeTaxRate = true
            },
            // 变更含税税率
            setChangeTaxRatePurInvoice(){
                let that = this
                let parm = {}
                if(that.negative_flag == 0){
                    parm = {
                        invoice_no: that.dataDetail.Head.invoice_no,
                        order_type: 'pur',
                        old_tax_rate: that.old_tax_rate,
                        tax_rate: that.dataDetail.Head.tax_rate,
                        exchange_rate: that.dataDetail.Head.exchange_rate,
                        concurrent_time: that.dataDetail.Head.concurrent_time,
                    }
                } else {
                    parm = {
                        invoice_no: that.dataDetailRed.Head.invoice_no,
                        order_type: 'pur_n',
                        old_tax_rate: that.old_tax_rate,
                        tax_rate: that.dataDetailRed.Head.tax_rate,
                        exchange_rate: that.dataDetailRed.Head.exchange_rate,
                        concurrent_time: that.dataDetailRed.Head.concurrent_time,
                    }
                }
                that.$http.urlpost('/Finance/Invoice/ChanageSetTaxRate', parm, function (res) {
                    if (res.Success == 1) {
                        that.$message.success(that.$processdata.explainCallbackMsg(res.Msg))
                        that.visChangeTaxRate = false
                        if(that.negative_flag == 0){
                            that.getDetail(that.code)
                        } else {
                            that.getDetailRed(that.code)
                        }
                    }
                });
            },
            batchImport(){
                let that = this
                let parm = {
                    Code: that.dataDetailRed.Head.vender_code
                }
                that.$http.urlpost('/Pur/Invoice/GetPurReturnBatchImport', parm, function (res) {
                    if (res.Success == 1) {
                        that.$message.success(that.$processdata.explainCallbackMsg(res.Msg))
                    }
                });
            },
            beforeChangeAuditDate(){
                let that = this
                that.visChangeAuditDate = true
                let date = null
                if(that.negative_flag == 0){
                    date = new Date(that.dataDetail.Head.audit_period);
                } else {
                    date = new Date(that.dataDetailRed.Head.audit_period);
                }
                let currentMonth = date.getMonth();
                let nextMonth = ++currentMonth;
                let nextMonthFirstDay = new Date(date.getFullYear(), nextMonth, 1);
                let oneDay = 1000 * 60 * 60 * 24;
                let lastTime = new Date(nextMonthFirstDay - oneDay);
                let day = lastTime.getDate();
                if(that.negative_flag == 0){
                    that.audit_period = that.dataDetail.Head.audit_period + '-' + day
                } else {
                    that.audit_period = that.dataDetailRed.Head.audit_period + '-' + day
                }
            },
            changeAuditDate(){
                let that = this
                let parm = {}
                if(that.negative_flag == 0){
                    parm = {
                        invoice_no: that.dataDetail.Head.invoice_no,
                        audit_period: that.dataDetail.Head.audit_period,
                        concurrent_time: that.dataDetail.Head.concurrent_time,
                        auditdate: that.audit_period,
                        billtype: 2
                    }
                } else {
                    parm = {
                        invoice_no: that.dataDetailRed.Head.invoice_no,
                        audit_period: that.dataDetailRed.Head.audit_period,
                        concurrent_time: that.dataDetailRed.Head.concurrent_time,
                        auditdate: that.audit_period,
                        billtype: 2
                    }
                }
                that.$http.urlpost('/Finance/Invoice/ChanageAuditDate', parm, function (res) {
                    if (res.Success == 1) {
                        that.$message.success(that.$processdata.explainCallbackMsg(res.Msg))
                        that.visChangeAuditDate = false
                        if(that.negative_flag == 0){
                            that.getDetail(that.code)
                        } else {
                            that.getDetailRed(that.code)
                        }
                    }
                });
            },
            // 审核区间约束
            disabledDate(time){
                let that = this
                let starttime = new Date(that.auditCheckData.DBYM).getTime()
                let endtime = new Date(that.auditCheckData.SysYM).getTime()
                return time.getTime() < starttime || time.getTime() > endtime
            },
            beforeChangePayDate(){
                let that = this
                that.visChangePayDate = true
                if(that.negative_flag == 0){
                    that.payDate = (that.dataDetail.Head.payment_date == '' ? Common.methods.getDate() : that.dataDetail.Head.payment_date)
                } else {
                    that.payDate = (that.dataDetailRed.Head.payment_date == '' ? Common.methods.getDate() : that.dataDetailRed.Head.payment_date)
                }
            },
            changePayDate(){
                let that = this
                let parm = {}
                if(that.negative_flag == 0){
                    parm = {
                        invoice_no: that.dataDetail.Head.invoice_no,
                        paydate: that.payDate,
                        billtype: 2
                    }
                } else {
                    parm = {
                        invoice_no: that.dataDetailRed.Head.invoice_no,
                        paydate: that.payDate,
                        billtype: 2
                    }
                }
                that.$http.urlpost('/Finance/Invoice/ChanagePayMentDate', parm, function (res) {
                    if (res.Success == 1) {
                        that.$message.success(that.$processdata.explainCallbackMsg(res.Msg))
                        that.visChangePayDate = false
                    }
                    if(that.negative_flag == 0){
                        that.getDetail(that.code)
                    } else {
                        that.getDetailRed(that.code)
                    }
                });
            },
            checkDataChange(){
                let that = this
                //如果无保存权限，直接关闭
                if(that.negative_flag == 0){
                    if(that.$limits.authority('plv3', 221,1) < 1){
                        return false
                    }
                } else {
                    if(that.$limits.authority('plv3', 226,1) < 1){
                        return false
                    }
                }
                let flag = true
                if(that.negative_flag == 0){
                    let datacopy = that.dataDetail
                    for(let i = 0;i<datacopy.Lists.length;i++){
                        delete datacopy.Lists[i]['index']
                    }
                    for(let i = 0;i<datacopy.OtherCostList.length;i++){
                        delete datacopy.OtherCostList[i]['index']
                    }
                    flag =  that.oldDataDetail != JSON.stringify(datacopy)
                } else {
                    let datacopyred = that.dataDetailRed
                    for(let i = 0;i<datacopyred.Lists.length;i++){
                        delete datacopyred.Lists[i]['index']
                    }
                    flag =  that.oldDataDetailRed != JSON.stringify(datacopyred)
                }
                return flag
            },
            //删除照片
            handleRemove(file){
                let that = this
                console.log(file)
                this.$confirm(that.$t('getapi[8897]'), that.$t('getapi[194]'), {//'确定删除图片?'
                    confirmButtonText: that.$t('getapi[1146]'),
                    cancelButtonText: that.$t('getapi[2054]'),
                    type: 'warning'
                })
                    .then(() => {
                        let parm = {
                            invoice_no: file.invoice_no,
                            wxserviceid: file.wxserviceid,
                        }
                        that.$http.urlpost('/Finance/Invoice/DelInvoicePic', parm, function (res) {
                            if (res.Success == 1) {
                                that.$message.success(that.$processdata.explainCallbackMsg(res.Msg))
                                that.getDetail(that.code)
                            }
                        });
                    })
                    .catch(() => {
                        this.$message({
                            type: 'info',
                            message: that.$t('getapi[8574]')
                        });
                    });
            },
            handlePictureCardPreview(file) {
                this.dialogImageUrl = file.url;
                this.dialogVisible = true;
            },
            selectInfo(tab, event) {
                let that = this;
                that.RightSelectIndex = tab.name;
                that.$nextTick(function(){
                    that.$processdata.initFormRight(that.RightSelectIndex)
                });
            },
        }
    };
</script>

<style scoped lang="less">
    table {
        border-collapse: separate;
        border-spacing: 0px 5px;
        td {
            padding-left: 3px;
            white-space: pre;
        }
    }
    /deep/.el-upload--picture-card{
        display: none;
    }
    /deep/.el-upload-list--picture-card .el-upload-list__item{
        width:650px;
        height:350px
    }
    /deep/.yellow{
        background: #EE7700;
    }
    /deep/.yellow2{
        background:#a1a337;
    }
</style>
